<template>
<svg width="1157" height="250" viewBox="0 0 1157 250" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1014.03 181.686C1012.2 182.827 1010.42 184.526 1008.79 185.905C1007.95 186.617 1007.12 187.342 1006.29 188.067C1005.67 188.293 1005.04 188.483 1004.37 188.614C1001.88 189.101 999.335 189.053 996.828 188.661C990.554 187.663 985.077 184.419 979.517 181.556C974.693 179.072 969.251 176.957 963.904 179.143C961.255 180.225 959.021 182.268 956.823 184.063C952.558 187.544 948.352 191.18 944.526 195.149C942.399 197.359 944.918 195.517 946.677 194.175C946.831 194.175 947.413 193.925 948.435 193.391C949.207 193.189 949.98 193.058 950.776 192.998C951.964 192.915 953.152 192.998 954.328 193.189C957.726 193.747 960.839 195.422 963.845 197.003C969.56 200.021 975.406 203.17 981.988 203.657C987.263 204.049 991.968 202.362 996.174 199.272C1000.59 196.017 1004.76 192.297 1008.79 188.578C1009.07 188.329 1009.33 188.079 1009.6 187.83C1010.35 187.188 1010.84 186.724 1011.06 186.439C1012.65 184.883 1014.13 183.231 1015.2 181.27C1015.73 180.296 1014.19 181.603 1014.06 181.686H1014.03Z" fill="url(#paint0_linear_371_24252)"/>
<path d="M486.887 64.5093C481.564 62.62 478.107 58.8651 475.588 53.9339C474.637 52.0802 473.485 49.8226 471.322 49.2165C468.982 48.563 466.701 50.286 464.277 49.7869C462.209 49.3591 460.332 47.9808 459.394 46.0677C458.217 43.6674 458.776 40.8988 458.704 38.3441C458.645 36.027 458.075 33.2821 455.877 32.0582C454.166 31.1076 452.158 31.476 450.328 31.8206C448.237 32.2127 446.003 32.7118 443.995 31.7255C441.393 30.4422 440.229 27.4122 439.29 24.8574C439.29 24.8693 438.898 26.0576 438.934 25.9268C438.708 26.7943 438.518 27.6855 438.34 28.5766C438.138 29.551 437.401 31.3928 437.77 32.3672C438.577 34.5654 439.492 36.9895 441.37 38.5223C443.092 39.9363 445.183 39.9482 447.275 39.6155C449.092 39.3303 450.97 38.7362 452.811 39.057C455.568 39.5204 456.839 42.087 457.089 44.6655C457.516 49.1571 456.079 54.3498 461.14 56.75C463.445 57.8432 465.334 57.1659 467.675 56.7144C470.241 56.2153 471.916 57.7125 473.176 59.792C474.625 62.1922 475.623 64.7232 477.524 66.8383C479.663 69.2148 482.36 70.9496 485.366 72.0072C485.295 71.9834 487.493 64.7113 486.887 64.4974V64.5093Z" fill="url(#paint1_linear_371_24252)"/>
<path d="M814.333 96.4631C814.195 96.9762 814.077 97.5089 813.979 98.0614C813.939 98.1601 813.88 98.2587 813.841 98.3377C813.624 98.7717 813.367 99.1861 813.072 99.561C812.539 100.271 811.888 100.883 811.198 101.436C809.68 102.639 807.925 103.527 806.131 104.218C804.277 104.928 802.325 105.421 800.353 105.658C798.244 105.915 796.055 105.658 794.142 106.743C793.945 106.862 793.787 108.164 793.787 108.184C793.59 109.348 793.432 110.532 793.294 111.696C793.156 112.86 793.018 114.044 792.939 115.228C792.939 115.386 792.939 116.708 792.939 116.708C795.246 115.425 798.165 115.879 800.708 115.386C803.252 114.893 805.756 114.005 808.004 112.722C809.897 111.637 811.691 110.177 812.697 108.204C814.156 105.323 814.176 101.396 814.452 98.2785C814.472 98.0219 814.846 94.6281 814.333 96.4434V96.4631Z" fill="url(#paint2_linear_371_24252)"/>
<path d="M856.79 125.373C856.79 125.373 848.831 131.426 849.281 132.157C851.217 135.245 855.206 136.687 858.218 138.352C858.726 138.637 861.718 135.529 862.128 135.163C862.422 134.899 865.668 131.548 865.726 131.589C862.715 129.923 858.726 128.481 856.79 125.393V125.373Z" fill="url(#paint3_linear_371_24252)"/>
<path d="M933.692 182.949C932.985 182.3 932.023 181.732 931.237 181.204C930.825 180.92 930.413 180.656 930 180.393C929.824 180.149 929.667 179.906 929.529 179.622C928.999 178.587 928.704 177.471 928.547 176.314C928.174 173.433 928.862 170.592 929.352 167.772C929.784 165.317 930 162.659 928.39 160.589C927.585 159.575 926.446 158.864 925.406 158.134C923.383 156.714 921.302 155.354 919.122 154.198C917.905 153.548 919.024 154.421 919.81 155.009C919.81 155.07 920.006 155.293 920.359 155.679C920.536 155.983 920.693 156.308 920.831 156.653C921.027 157.16 921.145 157.688 921.204 158.235C921.4 159.798 921.086 161.38 920.791 162.923C920.242 165.824 919.653 168.807 920.281 171.769C920.791 174.143 922.107 175.99 923.953 177.41C925.897 178.911 928.017 180.271 930.099 181.549C930.236 181.63 930.374 181.711 930.511 181.813C930.884 182.056 931.139 182.219 931.296 182.28C932.16 182.767 933.044 183.193 934.026 183.416C934.497 183.517 933.751 183.01 933.712 182.969L933.692 182.949Z" fill="url(#paint4_linear_371_24252)"/>
<path d="M833.086 66.9907C832.658 66.6104 832.076 66.2777 831.601 65.9688C831.351 65.8024 831.102 65.6479 830.852 65.4935C830.745 65.3509 830.65 65.2083 830.567 65.0419C830.246 64.4359 830.068 63.7824 829.973 63.1051C829.747 61.4178 830.163 59.7542 830.46 58.1026C830.722 56.6648 830.852 55.1082 829.878 53.8961C829.391 53.302 828.702 52.8861 828.072 52.4584C826.848 51.6266 825.589 50.8305 824.27 50.1532C823.533 49.7729 824.211 50.2839 824.686 50.6285C824.686 50.6641 824.805 50.7948 825.019 51.0206C825.126 51.1988 825.221 51.3889 825.304 51.5909C825.423 51.888 825.494 52.1969 825.53 52.5178C825.648 53.4327 825.458 54.3596 825.28 55.2626C824.947 56.9618 824.591 58.7086 824.971 60.4434C825.28 61.8337 826.076 62.915 827.193 63.7467C828.369 64.626 829.652 65.4222 830.912 66.1708C830.995 66.2183 831.078 66.2658 831.161 66.3252C831.387 66.4678 831.542 66.5629 831.637 66.5985C832.159 66.8837 832.694 67.1333 833.288 67.264C833.573 67.3234 833.122 67.0263 833.098 67.0025L833.086 66.9907Z" fill="url(#paint5_linear_371_24252)"/>
<path d="M680.743 152.616C680.91 152.39 680.458 152.735 680.506 152.699C680.137 152.901 679.721 153.317 679.412 153.578C678.711 154.172 677.832 154.79 677.286 155.539C674.339 159.567 674.612 164.997 678.058 168.645C678.224 168.812 681.682 165.651 681.599 165.568C678.236 161.991 677.832 156.596 680.743 152.616Z" fill="url(#paint6_linear_371_24252)"/>
<path d="M625.888 174.289C625.841 174.895 625.841 175.513 625.852 176.131C625.829 176.25 625.793 176.357 625.757 176.476C625.627 177.01 625.437 177.521 625.199 178.02C624.771 178.924 624.189 179.767 623.559 180.54C622.169 182.227 620.411 183.629 618.581 184.817C616.692 186.041 614.648 187.039 612.522 187.764C610.24 188.548 607.757 188.774 605.88 190.402C605.678 190.58 605.82 192.066 605.832 192.077C605.88 193.42 605.987 194.751 606.106 196.082C606.224 197.413 606.355 198.755 606.545 200.074C606.569 200.253 606.89 201.714 606.89 201.714C609.159 199.754 612.486 199.575 615.195 198.447C617.904 197.306 620.47 195.749 622.668 193.8C624.522 192.161 626.173 190.129 626.827 187.693C627.777 184.164 626.886 179.791 626.458 176.274C626.423 176 626.054 172.139 625.888 174.277V174.289Z" fill="url(#paint7_linear_371_24252)"/>
<path d="M998.268 64.1969C998.268 64.1969 990.106 63.4604 990.014 64.1355C989.584 67.0507 991.303 70.1194 992.315 72.7585C992.469 73.1881 995.997 72.9733 996.427 73.004C996.764 73.004 1000.54 72.7892 1000.57 72.8199C999.557 70.1808 997.838 67.1121 998.268 64.1969Z" fill="url(#paint8_linear_371_24252)"/>
<path d="M1058.04 138.581C1057.95 137.783 1057.64 136.955 1057.43 136.188C1057.3 135.789 1057.21 135.42 1057.09 135.022C1057.09 134.776 1057.15 134.531 1057.21 134.285C1057.43 133.364 1057.82 132.536 1058.35 131.769C1059.64 129.835 1061.57 128.485 1063.35 127.074C1064.91 125.846 1066.45 124.343 1066.54 122.225C1066.57 121.182 1066.23 120.108 1065.99 119.126C1065.47 117.162 1064.91 115.198 1064.18 113.326C1063.78 112.283 1063.99 113.387 1064.18 114.185C1064.18 114.247 1064.18 114.461 1064.18 114.891C1064.11 115.167 1064.05 115.443 1063.96 115.72C1063.81 116.119 1063.59 116.517 1063.35 116.886C1062.64 117.929 1061.6 118.727 1060.62 119.463C1058.75 120.906 1056.78 122.379 1055.62 124.496C1054.66 126.184 1054.51 128.025 1054.91 129.897C1055.31 131.861 1055.92 133.825 1056.54 135.727C1056.57 135.85 1056.63 135.973 1056.66 136.126C1056.75 136.464 1056.84 136.709 1056.9 136.832C1057.18 137.599 1057.52 138.336 1058.01 139.011C1058.25 139.348 1058.04 138.612 1058.04 138.581Z" fill="url(#paint9_linear_371_24252)"/>
<path d="M1020.48 128.731C1020.85 128.639 1020.08 128.578 1020.15 128.608C1019.59 128.485 1018.8 128.547 1018.24 128.516C1016.98 128.516 1015.54 128.332 1014.28 128.608C1007.63 130.081 1003.02 135.912 1003.24 142.755C1003.24 143.062 1009.65 142.939 1009.65 142.785C1009.44 136.096 1013.89 130.204 1020.45 128.731H1020.48Z" fill="url(#paint10_linear_371_24252)"/>
<path d="M944.663 101.481C944.08 102.064 943.497 102.678 942.976 103.353C942.853 103.445 942.699 103.537 942.577 103.629C941.963 104.059 941.319 104.396 940.613 104.703C939.355 105.256 938.005 105.593 936.655 105.808C933.709 106.299 930.641 106.115 927.695 105.685C924.657 105.225 921.65 104.427 918.797 103.23C915.759 101.972 912.998 99.9775 909.592 99.9468C909.224 99.9468 908.027 101.604 908.027 101.604C906.861 103.015 905.756 104.488 904.682 105.961C903.608 107.434 902.535 108.938 901.522 110.442C901.399 110.656 900.387 112.436 900.387 112.436C904.498 112.467 908.058 115.29 911.862 116.579C915.667 117.868 919.717 118.574 923.737 118.574C927.112 118.574 930.641 117.96 933.525 116.057C937.667 113.295 940.705 108.017 943.467 104.028C943.681 103.721 946.78 99.4251 944.694 101.481H944.663Z" fill="url(#paint11_linear_371_24252)"/>
<path d="M434.535 90.7905C434.535 90.7905 429.447 94.5294 429.731 94.9554C430.962 96.8485 433.517 97.7478 435.457 98.789C435.789 98.9546 437.705 97.0615 437.965 96.8249C438.155 96.6592 440.237 94.6004 440.261 94.6241C438.32 93.6065 435.765 92.7073 434.535 90.7905Z" fill="url(#paint12_linear_371_24252)"/>
<path d="M507.033 103.403C506.584 103.001 505.968 102.646 505.472 102.315C505.211 102.149 504.951 101.983 504.691 101.818C504.572 101.676 504.478 101.51 504.383 101.344C504.052 100.706 503.863 100.019 503.768 99.3093C503.531 97.5345 503.957 95.7834 504.288 94.0322C504.572 92.5177 504.691 90.8849 503.673 89.6071C503.176 88.9681 502.419 88.5422 501.757 88.0926C500.455 87.217 499.13 86.3651 497.758 85.6552C496.977 85.2529 497.687 85.7972 498.207 86.1521C498.207 86.1995 498.326 86.3414 498.562 86.5544C498.681 86.7437 498.775 86.9567 498.846 87.146C498.965 87.4536 499.036 87.7849 499.083 88.1162C499.201 89.0865 499.012 90.0567 498.823 91.0033C498.468 92.8017 498.089 94.6475 498.491 96.4696C498.823 97.9368 499.651 99.0727 500.834 99.9483C502.088 100.871 503.413 101.699 504.762 102.504C504.856 102.551 504.951 102.599 505.022 102.67C505.259 102.812 505.424 102.906 505.519 102.954C506.063 103.261 506.631 103.522 507.246 103.664C507.554 103.735 507.081 103.427 507.033 103.38V103.403Z" fill="url(#paint13_linear_371_24252)"/>
<path d="M480.273 116.821C480.438 116.584 479.965 116.939 480.012 116.916C479.61 117.129 479.184 117.555 478.853 117.839C478.119 118.454 477.196 119.116 476.605 119.897C473.505 124.157 473.789 129.86 477.409 133.717C477.575 133.906 481.219 130.57 481.148 130.475C477.599 126.713 477.197 121.033 480.249 116.821H480.273Z" fill="url(#paint14_linear_371_24252)"/>
<path d="M422.467 139.681C422.419 140.32 422.419 140.958 422.443 141.621C422.419 141.739 422.396 141.858 422.348 141.976C422.206 142.544 422.017 143.065 421.757 143.609C421.307 144.555 420.692 145.455 420.029 146.259C418.562 148.034 416.717 149.501 414.777 150.755C412.789 152.057 410.636 153.098 408.388 153.855C405.998 154.684 403.372 154.92 401.384 156.648C401.171 156.837 401.337 158.399 401.337 158.423C401.384 159.842 401.502 161.239 401.621 162.658C401.739 164.055 401.881 165.474 402.07 166.871C402.094 167.06 402.425 168.598 402.425 168.598C404.815 166.516 408.317 166.35 411.18 165.143C414.043 163.936 416.741 162.303 419.059 160.245C421.023 158.517 422.751 156.364 423.437 153.808C424.431 150.093 423.484 145.478 423.058 141.787C423.035 141.503 422.632 137.433 422.467 139.681Z" fill="url(#paint15_linear_371_24252)"/>
<path d="M314.604 5.61244C314.604 5.61244 309.851 1.45647 309.497 1.82598C307.916 3.43745 307.592 6.12707 306.996 8.24688C306.906 8.60617 309.169 10.0669 309.457 10.2697C309.66 10.4186 312.121 12.0051 312.103 12.0333C312.676 9.91866 313 7.22905 314.604 5.61244Z" fill="url(#paint16_linear_371_24252)"/>
<path d="M318.004 79.1219C318.3 78.5958 318.513 77.9183 318.729 77.3614C318.834 77.0714 318.939 76.7815 319.045 76.4915C319.158 76.3452 319.299 76.2169 319.44 76.0886C319.992 75.6267 320.621 75.2932 321.293 75.0469C322.975 74.4312 324.776 74.4675 326.558 74.4113C328.098 74.3603 329.717 74.1219 330.744 72.8517C331.26 72.2281 331.512 71.3966 331.808 70.6524C332.38 69.1922 332.925 67.7139 333.32 66.2203C333.544 65.3709 333.166 66.1818 332.933 66.7669C332.886 66.7772 332.773 66.9234 332.617 67.2006C332.458 67.3571 332.27 67.4957 332.101 67.606C331.826 67.7882 331.518 67.9293 331.205 68.0473C330.283 68.3731 329.295 68.3985 328.33 68.4189C326.497 68.4622 324.614 68.4927 322.922 69.2803C321.561 69.9217 320.632 70.9764 320.034 72.3211C319.405 73.7454 318.883 75.2185 318.39 76.7095C318.364 76.8122 318.339 76.9148 318.285 76.9995C318.197 77.2613 318.141 77.4435 318.115 77.5461C317.933 78.1441 317.802 78.7549 317.797 79.3862C317.794 79.7019 317.992 79.1732 318.028 79.1168L318.004 79.1219Z" fill="url(#paint17_linear_371_24252)"/>
<path d="M299.105 55.9048C299.372 56.0152 298.923 55.6301 298.957 55.6712C298.662 55.3247 298.153 55.0012 297.804 54.7393C297.045 54.1566 296.198 53.3994 295.307 52.9911C290.477 50.8883 284.971 52.4016 281.99 56.7718C281.841 56.9745 285.889 59.8086 285.966 59.7188C288.869 55.4384 294.327 53.8148 299.1 55.8817L299.105 55.9048Z" fill="url(#paint18_linear_371_24252)"/>
<path d="M264.261 4.42746C263.627 4.51974 263.003 4.6582 262.361 4.82491C262.241 4.82745 262.12 4.83001 261.994 4.80946C261.409 4.79396 260.86 4.722 260.272 4.58587C259.251 4.35214 258.239 3.94643 257.31 3.47403C255.26 2.42655 253.428 0.942828 251.783 -0.679481C250.081 -2.33773 248.598 -4.21412 247.372 -6.24443C246.045 -8.39794 245.245 -10.9107 243.128 -12.4766C242.897 -12.6434 241.408 -12.1433 241.385 -12.1381C240.009 -11.7842 238.672 -11.3661 237.311 -10.9429C235.974 -10.5248 234.618 -10.0784 233.297 -9.59104C233.117 -9.52691 231.687 -8.87011 231.687 -8.87011C234.238 -6.98843 235.159 -3.60565 236.957 -1.07221C238.756 1.46123 240.935 3.74066 243.447 5.55817C245.559 7.101 248.036 8.3205 250.68 8.43645C254.522 8.60139 258.822 6.67731 262.333 5.46141C262.605 5.37677 266.491 4.10191 264.261 4.42746Z" fill="url(#paint19_linear_371_24252)"/>
<path d="M34.2044 53.5303C34.2044 53.5303 29.1172 57.2692 29.4011 57.6951C30.6315 59.5883 33.187 60.4875 35.1272 61.5287C35.4585 61.6944 37.3751 59.8012 37.6354 59.5646C37.8247 59.399 39.9069 57.3402 39.9306 57.3638C37.9903 56.3463 35.4348 55.4471 34.2044 53.5303Z" fill="url(#paint20_linear_371_24252)"/>
<path d="M106.703 66.143C106.254 65.7407 105.638 65.3857 105.141 65.0544C104.881 64.8888 104.621 64.7231 104.361 64.5575C104.242 64.4155 104.148 64.2499 104.053 64.0842C103.722 63.4453 103.532 62.759 103.438 62.0491C103.201 60.2743 103.627 58.5231 103.958 56.772C104.242 55.2575 104.361 53.6247 103.343 52.3468C102.846 51.7079 102.089 51.2819 101.427 50.8323C100.125 49.9568 98.8001 49.1048 97.4278 48.3949C96.6469 47.9926 97.3568 48.5369 97.8773 48.8919C97.8773 48.9392 97.9956 49.0812 98.2323 49.2942C98.3506 49.4835 98.4452 49.6964 98.5162 49.8858C98.6345 50.1934 98.7055 50.5247 98.7528 50.856C98.8711 51.8262 98.6818 52.7964 98.4925 53.743C98.1376 55.5415 97.759 57.3873 98.1613 59.2094C98.4925 60.6766 99.3207 61.8124 100.504 62.688C101.758 63.6109 103.083 64.4392 104.432 65.2437C104.526 65.2911 104.621 65.3384 104.692 65.4094C104.929 65.5514 105.094 65.646 105.189 65.6934C105.733 66.001 106.301 66.2613 106.916 66.4033C107.224 66.4743 106.75 66.1666 106.703 66.1193V66.143Z" fill="url(#paint21_linear_371_24252)"/>
<path d="M79.9425 79.5607C80.1081 79.3241 79.6348 79.679 79.6822 79.6554C79.2799 79.8684 78.854 80.2943 78.5227 80.5783C77.7892 81.1935 76.8664 81.8561 76.2749 82.637C73.1752 86.8966 73.4591 92.5996 77.0794 96.4569C77.245 96.6462 80.8889 93.3095 80.8179 93.2149C77.2687 89.4523 76.8664 83.7729 79.9188 79.5607H79.9425Z" fill="url(#paint22_linear_371_24252)"/>
<path d="M22.1366 102.42C22.0893 103.059 22.0893 103.698 22.1129 104.361C22.0893 104.479 22.0656 104.597 22.0183 104.716C21.8763 105.284 21.687 105.804 21.4267 106.349C20.9772 107.295 20.3619 108.194 19.6994 108.999C18.2324 110.774 16.3868 112.241 14.4465 113.495C12.459 114.797 10.3057 115.838 8.05786 116.595C5.66802 117.423 3.04159 117.66 1.05401 119.387C0.841052 119.577 1.00667 121.139 1.00667 121.162C1.054 122.582 1.17229 123.978 1.2906 125.398C1.40891 126.794 1.55089 128.214 1.74018 129.61C1.76384 129.8 2.09513 131.338 2.09513 131.338C4.48496 129.255 7.98689 129.09 10.85 127.883C13.713 126.676 16.4105 125.043 18.7293 122.984C20.6932 121.257 22.4205 119.104 23.1067 116.548C24.1005 112.833 23.1541 108.218 22.7281 104.526C22.7045 104.242 22.3022 100.172 22.1366 102.42Z" fill="url(#paint23_linear_371_24252)"/>
<path d="M76.6634 160.112C76.6634 160.112 71.5762 163.851 71.8601 164.277C73.0905 166.17 75.646 167.069 77.5862 168.11C77.9175 168.276 79.8341 166.383 80.0944 166.146C80.2837 165.98 82.3659 163.922 82.3895 163.945C80.4493 162.928 77.8938 162.029 76.6634 160.112Z" fill="url(#paint24_linear_371_24252)"/>
<path d="M149.162 172.725C148.713 172.322 148.097 171.967 147.6 171.636C147.34 171.47 147.08 171.305 146.82 171.139C146.701 170.997 146.607 170.831 146.512 170.666C146.181 170.027 145.991 169.341 145.897 168.631C145.66 166.856 146.086 165.105 146.417 163.354C146.701 161.839 146.82 160.206 145.802 158.928C145.305 158.289 144.548 157.863 143.886 157.414C142.584 156.538 141.259 155.686 139.887 154.976C139.106 154.574 139.816 155.118 140.336 155.473C140.336 155.521 140.455 155.663 140.691 155.876C140.81 156.065 140.904 156.278 140.975 156.467C141.094 156.775 141.164 157.106 141.212 157.438C141.33 158.408 141.141 159.378 140.952 160.325C140.597 162.123 140.218 163.969 140.62 165.791C140.952 167.258 141.78 168.394 142.963 169.27C144.217 170.192 145.542 171.021 146.891 171.825C146.985 171.873 147.08 171.92 147.151 171.991C147.388 172.133 147.553 172.228 147.648 172.275C148.192 172.583 148.76 172.843 149.375 172.985C149.683 173.056 149.209 172.748 149.162 172.701V172.725Z" fill="url(#paint25_linear_371_24252)"/>
<path d="M122.401 186.143C122.567 185.906 122.094 186.261 122.141 186.237C121.739 186.45 121.313 186.876 120.982 187.16C120.248 187.776 119.325 188.438 118.734 189.219C115.634 193.479 115.918 199.182 119.538 203.039C119.704 203.228 123.348 199.892 123.277 199.797C119.728 196.034 119.325 190.355 122.378 186.143H122.401Z" fill="url(#paint26_linear_371_24252)"/>
<path d="M64.5956 209.002C64.5483 209.641 64.5482 210.28 64.5719 210.943C64.5482 211.061 64.5246 211.179 64.4773 211.298C64.3353 211.866 64.146 212.386 63.8857 212.931C63.4362 213.877 62.8209 214.776 62.1584 215.581C60.6914 217.356 58.8458 218.823 56.9055 220.077C54.9179 221.379 52.7647 222.42 50.5168 223.177C48.127 224.005 45.5006 224.242 43.513 225.97C43.3 226.159 43.4657 227.721 43.4657 227.744C43.513 229.164 43.6313 230.56 43.7496 231.98C43.8679 233.376 44.0099 234.796 44.1992 236.192C44.2228 236.382 44.5541 237.92 44.5541 237.92C46.9439 235.837 50.4459 235.672 53.3089 234.465C56.172 233.258 58.8694 231.625 61.1883 229.566C63.1522 227.839 64.8795 225.686 65.5657 223.13C66.5595 219.415 65.613 214.8 65.1871 211.108C65.1635 210.825 64.7612 206.754 64.5956 209.002Z" fill="url(#paint27_linear_371_24252)"/>
<path d="M262.964 178.309C262.964 178.309 257.877 182.048 258.161 182.473C259.391 184.367 261.947 185.266 263.887 186.307C264.218 186.473 266.135 184.58 266.395 184.343C266.584 184.177 268.667 182.118 268.69 182.142C266.75 181.125 264.195 180.225 262.964 178.309Z" fill="url(#paint28_linear_371_24252)"/>
<path d="M335.463 190.921C335.013 190.519 334.398 190.164 333.901 189.833C333.641 189.667 333.381 189.501 333.12 189.336C333.002 189.194 332.907 189.028 332.813 188.863C332.482 188.224 332.292 187.537 332.198 186.827C331.961 185.053 332.387 183.301 332.718 181.55C333.002 180.036 333.12 178.403 332.103 177.125C331.606 176.486 330.849 176.06 330.186 175.611C328.885 174.735 327.56 173.883 326.188 173.173C325.407 172.771 326.117 173.315 326.637 173.67C326.637 173.718 326.755 173.86 326.992 174.072C327.11 174.262 327.205 174.475 327.276 174.664C327.394 174.972 327.465 175.303 327.513 175.634C327.631 176.605 327.442 177.575 327.252 178.521C326.897 180.32 326.519 182.166 326.921 183.988C327.252 185.455 328.08 186.591 329.264 187.466C330.518 188.389 331.843 189.217 333.191 190.022C333.286 190.069 333.381 190.117 333.452 190.188C333.688 190.33 333.854 190.424 333.949 190.472C334.493 190.779 335.061 191.04 335.676 191.182C335.983 191.253 335.51 190.945 335.463 190.898V190.921Z" fill="url(#paint29_linear_371_24252)"/>
<path d="M308.702 204.34C308.868 204.103 308.395 204.458 308.442 204.434C308.04 204.647 307.614 205.073 307.282 205.357C306.549 205.972 305.626 206.635 305.035 207.416C301.935 211.675 302.219 217.378 305.839 221.236C306.005 221.425 309.649 218.088 309.578 217.994C306.028 214.231 305.626 208.552 308.679 204.34H308.702Z" fill="url(#paint30_linear_371_24252)"/>
<path d="M250.896 227.199C250.849 227.838 250.849 228.477 250.873 229.14C250.849 229.258 250.825 229.376 250.778 229.495C250.636 230.063 250.447 230.583 250.187 231.127C249.737 232.074 249.122 232.973 248.459 233.778C246.992 235.553 245.147 237.02 243.206 238.274C241.219 239.575 239.065 240.617 236.818 241.374C234.428 242.202 231.801 242.439 229.814 244.166C229.601 244.356 229.766 245.917 229.766 245.941C229.814 247.361 229.932 248.757 230.05 250.177C230.169 251.573 230.311 252.993 230.5 254.389C230.524 254.578 230.855 256.117 230.855 256.117C233.245 254.034 236.747 253.869 239.61 252.662C242.473 251.455 245.17 249.822 247.489 247.763C249.453 246.036 251.18 243.882 251.866 241.327C252.86 237.611 251.914 232.997 251.488 229.305C251.464 229.021 251.062 224.951 250.896 227.199Z" fill="url(#paint31_linear_371_24252)"/>
<path d="M1088.01 148.55C1088.01 148.55 1082.37 152.693 1082.69 153.165C1084.05 155.262 1086.88 156.259 1089.03 157.413C1089.4 157.596 1091.52 155.498 1091.81 155.236C1092.02 155.053 1094.33 152.772 1094.36 152.798C1092.21 151.67 1089.37 150.674 1088.01 148.55Z" fill="url(#paint32_linear_371_24252)"/>
<path d="M1138.69 177.392C1138.87 177.13 1138.35 177.523 1138.4 177.497C1137.95 177.733 1137.48 178.205 1137.12 178.519C1136.3 179.201 1135.28 179.935 1134.62 180.8C1131.19 185.52 1131.5 191.839 1135.52 196.113C1135.7 196.322 1139.74 192.625 1139.66 192.521C1135.73 188.352 1135.28 182.059 1138.66 177.392H1138.69Z" fill="url(#paint33_linear_371_24252)"/>
<path d="M1074.64 202.72C1074.59 203.428 1074.59 204.136 1074.61 204.87C1074.59 205.001 1074.56 205.132 1074.51 205.263C1074.35 205.892 1074.14 206.469 1073.85 207.072C1073.36 208.121 1072.67 209.117 1071.94 210.009C1070.31 211.975 1068.27 213.601 1066.12 214.99C1063.92 216.433 1061.53 217.586 1059.04 218.425C1056.39 219.343 1053.48 219.605 1051.28 221.519C1051.04 221.729 1051.23 223.459 1051.23 223.486C1051.28 225.059 1051.41 226.606 1051.54 228.179C1051.67 229.726 1051.83 231.299 1052.04 232.846C1052.07 233.056 1052.43 234.76 1052.43 234.76C1055.08 232.453 1058.96 232.269 1062.13 230.932C1065.31 229.595 1068.3 227.786 1070.86 225.505C1073.04 223.591 1074.95 221.205 1075.71 218.373C1076.82 214.256 1075.77 209.144 1075.3 205.053C1075.27 204.739 1074.82 200.229 1074.64 202.72Z" fill="url(#paint34_linear_371_24252)"/>
<path d="M667.341 168.182C667.341 168.182 664.787 170.06 664.93 170.273C665.547 171.224 666.831 171.676 667.805 172.198C667.971 172.282 668.934 171.331 669.064 171.212C669.159 171.129 670.205 170.095 670.217 170.107C669.243 169.596 667.959 169.145 667.341 168.182Z" fill="url(#paint35_linear_371_24252)"/>
<path d="M703.757 174.515C703.532 174.313 703.223 174.135 702.973 173.969C702.842 173.886 702.712 173.802 702.581 173.719C702.522 173.648 702.474 173.565 702.427 173.482C702.26 173.161 702.165 172.816 702.118 172.46C701.999 171.569 702.213 170.689 702.379 169.81C702.522 169.049 702.581 168.23 702.07 167.588C701.821 167.267 701.44 167.053 701.108 166.827C700.454 166.388 699.789 165.96 699.1 165.604C698.708 165.402 699.064 165.675 699.326 165.853C699.326 165.877 699.385 165.948 699.504 166.055C699.563 166.15 699.611 166.257 699.646 166.352C699.706 166.507 699.741 166.673 699.765 166.839C699.825 167.326 699.73 167.814 699.635 168.289C699.456 169.192 699.266 170.119 699.468 171.034C699.635 171.771 700.05 172.341 700.644 172.781C701.274 173.244 701.94 173.66 702.617 174.064C702.664 174.088 702.712 174.111 702.747 174.147C702.866 174.218 702.949 174.266 702.997 174.29C703.27 174.444 703.555 174.575 703.864 174.646C704.019 174.682 703.781 174.527 703.757 174.504V174.515Z" fill="url(#paint36_linear_371_24252)"/>
<path d="M690.307 181.253C690.39 181.134 690.152 181.312 690.176 181.3C689.974 181.407 689.76 181.621 689.594 181.764C689.226 182.073 688.762 182.406 688.465 182.798C686.909 184.937 687.051 187.8 688.869 189.737C688.952 189.832 690.782 188.157 690.746 188.109C688.964 186.22 688.762 183.368 690.295 181.253H690.307Z" fill="url(#paint37_linear_371_24252)"/>
<path d="M661.293 192.732C661.269 193.052 661.269 193.373 661.281 193.706C661.269 193.765 661.258 193.825 661.234 193.884C661.162 194.169 661.067 194.431 660.937 194.704C660.711 195.179 660.402 195.631 660.069 196.035C659.333 196.926 658.406 197.663 657.432 198.293C656.434 198.946 655.353 199.469 654.224 199.849C653.024 200.265 651.705 200.384 650.707 201.251C650.6 201.346 650.683 202.131 650.683 202.143C650.707 202.856 650.766 203.557 650.826 204.27C650.885 204.971 650.956 205.684 651.051 206.385C651.063 206.48 651.23 207.252 651.23 207.252C652.43 206.206 654.188 206.123 655.626 205.517C657.063 204.911 658.418 204.091 659.582 203.058C660.568 202.19 661.436 201.109 661.78 199.825C662.279 197.96 661.804 195.643 661.59 193.789C661.578 193.647 661.376 191.603 661.293 192.732Z" fill="url(#paint38_linear_371_24252)"/>
<path d="M1057.81 86.2173C1057.81 86.2173 1052.55 82.3526 1052.84 81.9124C1054.12 79.9556 1056.76 79.0261 1058.76 77.9499C1059.1 77.7787 1061.09 79.7354 1061.36 79.98C1061.55 80.1513 1063.7 82.2793 1063.73 82.2548C1061.72 83.3066 1059.08 84.236 1057.81 86.2173Z" fill="url(#paint39_linear_371_24252)"/>
<path d="M1132.75 73.1808C1132.28 73.5966 1131.64 73.9635 1131.13 74.306C1130.86 74.4772 1130.59 74.6484 1130.32 74.8196C1130.2 74.9664 1130.1 75.1376 1130.01 75.3088C1129.66 75.9692 1129.47 76.6785 1129.37 77.4123C1129.13 79.2468 1129.57 81.0568 1129.91 82.8669C1130.2 84.4323 1130.32 86.12 1129.27 87.4408C1128.76 88.1012 1127.98 88.5415 1127.29 89.0063C1125.95 89.9113 1124.58 90.7918 1123.16 91.5256C1122.35 91.9414 1123.08 91.3788 1123.62 91.012C1123.62 90.963 1123.75 90.8163 1123.99 90.5961C1124.11 90.4005 1124.21 90.1803 1124.28 89.9846C1124.41 89.6667 1124.48 89.3242 1124.53 88.9818C1124.65 87.9789 1124.45 86.9761 1124.26 85.9977C1123.89 84.1388 1123.5 82.2309 1123.92 80.3475C1124.26 78.831 1125.11 77.6569 1126.34 76.7519C1127.63 75.798 1129 74.9419 1130.4 74.1103C1130.5 74.0614 1130.59 74.0124 1130.67 73.9391C1130.91 73.7923 1131.08 73.6945 1131.18 73.6455C1131.74 73.3276 1132.33 73.0585 1132.97 72.9117C1133.28 72.8384 1132.79 73.1564 1132.75 73.2053V73.1808Z" fill="url(#paint40_linear_371_24252)"/>
<path d="M1105.08 59.311C1105.26 59.5556 1104.77 59.1887 1104.82 59.2132C1104.4 58.9931 1103.96 58.5528 1103.62 58.2593C1102.86 57.6233 1101.91 56.9384 1101.29 56.1313C1098.09 51.7285 1098.38 45.8337 1102.13 41.8468C1102.3 41.6511 1106.06 45.0999 1105.99 45.1978C1102.32 49.0869 1101.91 54.9572 1105.06 59.311H1105.08Z" fill="url(#paint41_linear_371_24252)"/>
<path d="M1045.34 35.6835C1045.29 35.023 1045.29 34.3626 1045.31 33.6778C1045.29 33.5555 1045.26 33.4332 1045.21 33.3109C1045.07 32.7238 1044.87 32.1857 1044.6 31.6231C1044.14 30.6448 1043.5 29.7153 1042.82 28.8836C1041.3 27.0492 1039.39 25.5327 1037.39 24.2363C1035.33 22.891 1033.11 21.8148 1030.78 21.0321C1028.31 20.176 1025.6 19.9314 1023.54 18.1458C1023.32 17.9502 1023.5 16.3358 1023.5 16.3113C1023.54 14.8438 1023.67 13.4006 1023.79 11.9331C1023.91 10.4899 1024.06 9.02235 1024.25 7.57923C1024.28 7.38355 1024.62 5.79366 1024.62 5.79366C1027.09 7.94612 1030.71 8.11735 1033.67 9.3648C1036.63 10.6122 1039.42 12.3 1041.81 14.428C1043.84 16.2135 1045.63 18.4393 1046.34 21.081C1047.37 24.9212 1046.39 29.6908 1045.95 33.5065C1045.92 33.8001 1045.51 38.0071 1045.34 35.6835Z" fill="url(#paint42_linear_371_24252)"/>
<path d="M830.234 1.77956C830.008 1.57755 829.699 1.39932 829.45 1.23296C829.319 1.14978 829.188 1.06661 829.058 0.983429C828.998 0.912133 828.951 0.828957 828.903 0.745779C828.737 0.424952 828.642 0.080359 828.594 -0.276116C828.475 -1.1673 828.689 -2.04661 828.856 -2.92591C828.998 -3.68639 829.058 -4.50629 828.547 -5.14794C828.297 -5.46877 827.917 -5.68265 827.584 -5.90842C826.931 -6.34807 826.266 -6.77584 825.576 -7.13232C825.184 -7.33432 825.541 -7.06102 825.802 -6.88279C825.802 -6.85902 825.862 -6.78773 825.98 -6.68078C826.04 -6.58572 826.087 -6.47878 826.123 -6.38372C826.182 -6.22925 826.218 -6.06289 826.242 -5.89654C826.301 -5.40936 826.206 -4.92217 826.111 -4.44687C825.933 -3.5438 825.743 -2.61697 825.945 -1.70202C826.111 -0.965301 826.527 -0.394941 827.121 0.0447111C827.751 0.508129 828.416 0.924016 829.093 1.32802C829.141 1.35179 829.188 1.37555 829.224 1.4112C829.343 1.48249 829.426 1.53002 829.474 1.55379C829.747 1.70826 830.032 1.83897 830.341 1.91026C830.495 1.94591 830.258 1.79144 830.234 1.76767V1.77956Z" fill="url(#paint43_linear_371_24252)"/>
<path d="M816.784 8.51711C816.868 8.39828 816.63 8.57652 816.654 8.56464C816.452 8.67158 816.238 8.88547 816.071 9.02806C815.703 9.337 815.24 9.66971 814.943 10.0618C813.386 12.2007 813.529 15.0644 815.347 17.0012C815.43 17.0963 817.26 15.4208 817.224 15.3733C815.442 13.484 815.24 10.6322 816.772 8.51711H816.784Z" fill="url(#paint44_linear_371_24252)"/>
<path d="M787.771 19.9958C787.747 20.3166 787.747 20.6374 787.759 20.9702C787.747 21.0296 787.735 21.089 787.711 21.1484C787.64 21.4336 787.545 21.695 787.414 21.9683C787.189 22.4436 786.88 22.8951 786.547 23.2991C785.81 24.1903 784.884 24.927 783.909 25.5568C782.911 26.2103 781.83 26.7332 780.701 27.1134C779.501 27.5293 778.182 27.6481 777.184 28.5155C777.078 28.6106 777.161 29.3948 777.161 29.4067C777.184 30.1197 777.244 30.8207 777.303 31.5337C777.363 32.2348 777.434 32.9477 777.529 33.6488C777.541 33.7438 777.707 34.5162 777.707 34.5162C778.907 33.4705 780.666 33.3874 782.103 32.7814C783.541 32.1754 784.895 31.3555 786.06 30.3217C787.046 29.4543 787.913 28.373 788.258 27.0896C788.757 25.2241 788.282 22.907 788.068 21.0533C788.056 20.9107 787.854 18.867 787.771 19.9958Z" fill="url(#paint45_linear_371_24252)"/>
<path d="M898.398 62.0717C902.639 58.3406 907.606 57.1523 913.131 57.3543C915.21 57.4256 917.741 57.5207 919.321 55.9165C921.032 54.1817 920.628 51.3537 922.256 49.4762C923.634 47.884 925.761 46.9096 927.875 47.0284C930.537 47.171 932.687 49.0009 934.957 50.1892C937.012 51.2586 939.685 52.1023 941.824 50.7714C943.487 49.7376 944.141 47.8008 944.735 46.0422C945.412 44.0222 946.066 41.8239 947.907 40.5525C950.295 38.9008 953.503 39.3642 956.189 39.7801C956.177 39.7801 955.321 38.8533 955.428 38.9483C954.775 38.3186 954.086 37.7244 953.408 37.1422C952.66 36.5005 951.412 34.9558 950.379 34.7895C948.062 34.4211 945.495 34.0527 943.25 34.932C941.171 35.7519 940.149 37.57 939.424 39.5662C938.794 41.2892 938.39 43.2142 937.214 44.6757C935.456 46.8621 932.604 46.7195 930.228 45.6857C926.093 43.8796 922.267 40.1009 917.705 43.333C915.626 44.8064 915.293 46.7908 914.556 49.0603C913.749 51.5438 911.61 52.2805 909.198 52.3637C906.394 52.4587 903.697 52.1023 900.917 52.732C897.804 53.445 894.976 54.9541 892.588 57.0573C892.647 57.0097 897.923 62.4757 898.41 62.0479L898.398 62.0717Z" fill="url(#paint46_linear_371_24252)"/>
<defs>
<linearGradient id="paint0_linear_371_24252" x1="961.421" y1="176.161" x2="999.48" y2="202.263" gradientUnits="userSpaceOnUse">
<stop stop-color="#DD983D"/>
<stop offset="0.03" stop-color="#DD993E"/>
<stop offset="0.05" stop-color="#DF9F45"/>
<stop offset="0.06" stop-color="#E9B962"/>
<stop offset="0.07" stop-color="#F6DB88"/>
<stop offset="0.2" stop-color="#F5D986"/>
<stop offset="0.25" stop-color="#F2D37F"/>
<stop offset="0.28" stop-color="#EEC873"/>
<stop offset="0.31" stop-color="#E8B862"/>
<stop offset="0.33" stop-color="#E0A44C"/>
<stop offset="0.35" stop-color="#D68C32"/>
<stop offset="0.36" stop-color="#D28126"/>
<stop offset="0.49" stop-color="#CB6B1B"/>
<stop offset="0.67" stop-color="#C55619"/>
<stop offset="0.72" stop-color="#CD711B"/>
<stop offset="0.78" stop-color="#D4872B"/>
<stop offset="0.83" stop-color="#D78D31"/>
<stop offset="0.9" stop-color="#CB8226"/>
<stop offset="0.96" stop-color="#AD6614"/>
<stop offset="1" stop-color="#86410C"/>
</linearGradient>
<linearGradient id="paint1_linear_371_24252" x1="453.225" y1="37.7237" x2="477.894" y2="68.9374" gradientUnits="userSpaceOnUse">
<stop stop-color="#DD983D"/>
<stop offset="0.03" stop-color="#DD993E"/>
<stop offset="0.05" stop-color="#DF9F45"/>
<stop offset="0.06" stop-color="#E9B962"/>
<stop offset="0.07" stop-color="#F6DB88"/>
<stop offset="0.2" stop-color="#F5D986"/>
<stop offset="0.25" stop-color="#F2D37F"/>
<stop offset="0.28" stop-color="#EEC873"/>
<stop offset="0.31" stop-color="#E8B862"/>
<stop offset="0.33" stop-color="#E0A44C"/>
<stop offset="0.35" stop-color="#D68C32"/>
<stop offset="0.36" stop-color="#D28126"/>
<stop offset="0.49" stop-color="#CB6B1B"/>
<stop offset="0.67" stop-color="#C55619"/>
<stop offset="0.72" stop-color="#CD711B"/>
<stop offset="0.78" stop-color="#D4872B"/>
<stop offset="0.83" stop-color="#D78D31"/>
<stop offset="0.9" stop-color="#CB8226"/>
<stop offset="0.96" stop-color="#AD6614"/>
<stop offset="1" stop-color="#86410C"/>
</linearGradient>
<linearGradient id="paint2_linear_371_24252" x1="787.085" y1="107.76" x2="814.628" y2="105.167" gradientUnits="userSpaceOnUse">
<stop stop-color="#DD983D"/>
<stop offset="0.03" stop-color="#DD993E"/>
<stop offset="0.05" stop-color="#DF9F45"/>
<stop offset="0.06" stop-color="#E9B962"/>
<stop offset="0.07" stop-color="#F6DB88"/>
<stop offset="0.2" stop-color="#F5D986"/>
<stop offset="0.25" stop-color="#F2D37F"/>
<stop offset="0.28" stop-color="#EEC873"/>
<stop offset="0.31" stop-color="#E8B862"/>
<stop offset="0.33" stop-color="#E0A44C"/>
<stop offset="0.35" stop-color="#D68C32"/>
<stop offset="0.36" stop-color="#D28126"/>
<stop offset="0.49" stop-color="#CB6B1B"/>
<stop offset="0.67" stop-color="#C55619"/>
<stop offset="0.72" stop-color="#CD711B"/>
<stop offset="0.78" stop-color="#D4872B"/>
<stop offset="0.83" stop-color="#D78D31"/>
<stop offset="0.9" stop-color="#CB8226"/>
<stop offset="0.96" stop-color="#AD6614"/>
<stop offset="1" stop-color="#86410C"/>
</linearGradient>
<linearGradient id="paint3_linear_371_24252" x1="850.083" y1="123.931" x2="862.585" y2="136.456" gradientUnits="userSpaceOnUse">
<stop stop-color="#DD983D"/>
<stop offset="0.03" stop-color="#DD993E"/>
<stop offset="0.05" stop-color="#DF9F45"/>
<stop offset="0.06" stop-color="#E9B962"/>
<stop offset="0.07" stop-color="#F6DB88"/>
<stop offset="0.2" stop-color="#F5D986"/>
<stop offset="0.25" stop-color="#F2D37F"/>
<stop offset="0.28" stop-color="#EEC873"/>
<stop offset="0.31" stop-color="#E8B862"/>
<stop offset="0.33" stop-color="#E0A44C"/>
<stop offset="0.35" stop-color="#D68C32"/>
<stop offset="0.36" stop-color="#D28126"/>
<stop offset="0.49" stop-color="#CB6B1B"/>
<stop offset="0.67" stop-color="#C55619"/>
<stop offset="0.72" stop-color="#CD711B"/>
<stop offset="0.78" stop-color="#D4872B"/>
<stop offset="0.83" stop-color="#D78D31"/>
<stop offset="0.9" stop-color="#CB8226"/>
<stop offset="0.96" stop-color="#AD6614"/>
<stop offset="1" stop-color="#86410C"/>
</linearGradient>
<linearGradient id="paint4_linear_371_24252" x1="929.355" y1="159.315" x2="922.729" y2="179.343" gradientUnits="userSpaceOnUse">
<stop stop-color="#DD983D"/>
<stop offset="0.03" stop-color="#DD993E"/>
<stop offset="0.05" stop-color="#DF9F45"/>
<stop offset="0.06" stop-color="#E9B962"/>
<stop offset="0.07" stop-color="#F6DB88"/>
<stop offset="0.2" stop-color="#F5D986"/>
<stop offset="0.25" stop-color="#F2D37F"/>
<stop offset="0.28" stop-color="#EEC873"/>
<stop offset="0.31" stop-color="#E8B862"/>
<stop offset="0.33" stop-color="#E0A44C"/>
<stop offset="0.35" stop-color="#D68C32"/>
<stop offset="0.36" stop-color="#D28126"/>
<stop offset="0.49" stop-color="#CB6B1B"/>
<stop offset="0.67" stop-color="#C55619"/>
<stop offset="0.72" stop-color="#CD711B"/>
<stop offset="0.78" stop-color="#D4872B"/>
<stop offset="0.83" stop-color="#D78D31"/>
<stop offset="0.9" stop-color="#CB8226"/>
<stop offset="0.96" stop-color="#AD6614"/>
<stop offset="1" stop-color="#86410C"/>
</linearGradient>
<linearGradient id="paint5_linear_371_24252" x1="830.465" y1="53.1513" x2="826.686" y2="64.9536" gradientUnits="userSpaceOnUse">
<stop stop-color="#DD983D"/>
<stop offset="0.03" stop-color="#DD993E"/>
<stop offset="0.05" stop-color="#DF9F45"/>
<stop offset="0.06" stop-color="#E9B962"/>
<stop offset="0.07" stop-color="#F6DB88"/>
<stop offset="0.2" stop-color="#F5D986"/>
<stop offset="0.25" stop-color="#F2D37F"/>
<stop offset="0.28" stop-color="#EEC873"/>
<stop offset="0.31" stop-color="#E8B862"/>
<stop offset="0.33" stop-color="#E0A44C"/>
<stop offset="0.35" stop-color="#D68C32"/>
<stop offset="0.36" stop-color="#D28126"/>
<stop offset="0.49" stop-color="#CB6B1B"/>
<stop offset="0.67" stop-color="#C55619"/>
<stop offset="0.72" stop-color="#CD711B"/>
<stop offset="0.78" stop-color="#D4872B"/>
<stop offset="0.83" stop-color="#D78D31"/>
<stop offset="0.9" stop-color="#CB8226"/>
<stop offset="0.96" stop-color="#AD6614"/>
<stop offset="1" stop-color="#86410C"/>
</linearGradient>
<linearGradient id="paint6_linear_371_24252" x1="678.759" y1="153.543" x2="678.307" y2="167.077" gradientUnits="userSpaceOnUse">
<stop stop-color="#DD983D"/>
<stop offset="0.03" stop-color="#DD993E"/>
<stop offset="0.05" stop-color="#DF9F45"/>
<stop offset="0.06" stop-color="#E9B962"/>
<stop offset="0.07" stop-color="#F6DB88"/>
<stop offset="0.2" stop-color="#F5D986"/>
<stop offset="0.25" stop-color="#F2D37F"/>
<stop offset="0.28" stop-color="#EEC873"/>
<stop offset="0.31" stop-color="#E8B862"/>
<stop offset="0.33" stop-color="#E0A44C"/>
<stop offset="0.35" stop-color="#D68C32"/>
<stop offset="0.36" stop-color="#D28126"/>
<stop offset="0.49" stop-color="#CB6B1B"/>
<stop offset="0.67" stop-color="#C55619"/>
<stop offset="0.72" stop-color="#CD711B"/>
<stop offset="0.78" stop-color="#D4872B"/>
<stop offset="0.83" stop-color="#D78D31"/>
<stop offset="0.9" stop-color="#CB8226"/>
<stop offset="0.96" stop-color="#AD6614"/>
<stop offset="1" stop-color="#86410C"/>
</linearGradient>
<linearGradient id="paint7_linear_371_24252" x1="598.758" y1="193.335" x2="628.727" y2="184.034" gradientUnits="userSpaceOnUse">
<stop stop-color="#DD983D"/>
<stop offset="0.03" stop-color="#DD993E"/>
<stop offset="0.05" stop-color="#DF9F45"/>
<stop offset="0.06" stop-color="#E9B962"/>
<stop offset="0.07" stop-color="#F6DB88"/>
<stop offset="0.2" stop-color="#F5D986"/>
<stop offset="0.25" stop-color="#F2D37F"/>
<stop offset="0.28" stop-color="#EEC873"/>
<stop offset="0.31" stop-color="#E8B862"/>
<stop offset="0.33" stop-color="#E0A44C"/>
<stop offset="0.35" stop-color="#D68C32"/>
<stop offset="0.36" stop-color="#D28126"/>
<stop offset="0.49" stop-color="#CB6B1B"/>
<stop offset="0.67" stop-color="#C55619"/>
<stop offset="0.72" stop-color="#CD711B"/>
<stop offset="0.78" stop-color="#D4872B"/>
<stop offset="0.83" stop-color="#D78D31"/>
<stop offset="0.9" stop-color="#CB8226"/>
<stop offset="0.96" stop-color="#AD6614"/>
<stop offset="1" stop-color="#86410C"/>
</linearGradient>
<linearGradient id="paint8_linear_371_24252" x1="994.804" y1="59.5191" x2="995.443" y2="73.9374" gradientUnits="userSpaceOnUse">
<stop stop-color="#DD983D"/>
<stop offset="0.03" stop-color="#DD993E"/>
<stop offset="0.05" stop-color="#DF9F45"/>
<stop offset="0.06" stop-color="#E9B962"/>
<stop offset="0.07" stop-color="#F6DB88"/>
<stop offset="0.2" stop-color="#F5D986"/>
<stop offset="0.25" stop-color="#F2D37F"/>
<stop offset="0.28" stop-color="#EEC873"/>
<stop offset="0.31" stop-color="#E8B862"/>
<stop offset="0.33" stop-color="#E0A44C"/>
<stop offset="0.35" stop-color="#D68C32"/>
<stop offset="0.36" stop-color="#D28126"/>
<stop offset="0.49" stop-color="#CB6B1B"/>
<stop offset="0.67" stop-color="#C55619"/>
<stop offset="0.72" stop-color="#CD711B"/>
<stop offset="0.78" stop-color="#D4872B"/>
<stop offset="0.83" stop-color="#D78D31"/>
<stop offset="0.9" stop-color="#CB8226"/>
<stop offset="0.96" stop-color="#AD6614"/>
<stop offset="1" stop-color="#86410C"/>
</linearGradient>
<linearGradient id="paint9_linear_371_24252" x1="1067.88" y1="122.074" x2="1053.36" y2="130.772" gradientUnits="userSpaceOnUse">
<stop stop-color="#DD983D"/>
<stop offset="0.03" stop-color="#DD993E"/>
<stop offset="0.05" stop-color="#DF9F45"/>
<stop offset="0.06" stop-color="#E9B962"/>
<stop offset="0.07" stop-color="#F6DB88"/>
<stop offset="0.2" stop-color="#F5D986"/>
<stop offset="0.25" stop-color="#F2D37F"/>
<stop offset="0.28" stop-color="#EEC873"/>
<stop offset="0.31" stop-color="#E8B862"/>
<stop offset="0.33" stop-color="#E0A44C"/>
<stop offset="0.35" stop-color="#D68C32"/>
<stop offset="0.36" stop-color="#D28126"/>
<stop offset="0.49" stop-color="#CB6B1B"/>
<stop offset="0.67" stop-color="#C55619"/>
<stop offset="0.72" stop-color="#CD711B"/>
<stop offset="0.78" stop-color="#D4872B"/>
<stop offset="0.83" stop-color="#D78D31"/>
<stop offset="0.9" stop-color="#CB8226"/>
<stop offset="0.96" stop-color="#AD6614"/>
<stop offset="1" stop-color="#86410C"/>
</linearGradient>
<linearGradient id="paint10_linear_371_24252" x1="1017.61" y1="127.769" x2="1004.92" y2="141.255" gradientUnits="userSpaceOnUse">
<stop stop-color="#DD983D"/>
<stop offset="0.03" stop-color="#DD993E"/>
<stop offset="0.05" stop-color="#DF9F45"/>
<stop offset="0.06" stop-color="#E9B962"/>
<stop offset="0.07" stop-color="#F6DB88"/>
<stop offset="0.2" stop-color="#F5D986"/>
<stop offset="0.25" stop-color="#F2D37F"/>
<stop offset="0.28" stop-color="#EEC873"/>
<stop offset="0.31" stop-color="#E8B862"/>
<stop offset="0.33" stop-color="#E0A44C"/>
<stop offset="0.35" stop-color="#D68C32"/>
<stop offset="0.36" stop-color="#D28126"/>
<stop offset="0.49" stop-color="#CB6B1B"/>
<stop offset="0.67" stop-color="#C55619"/>
<stop offset="0.72" stop-color="#CD711B"/>
<stop offset="0.78" stop-color="#D4872B"/>
<stop offset="0.83" stop-color="#D78D31"/>
<stop offset="0.9" stop-color="#CB8226"/>
<stop offset="0.96" stop-color="#AD6614"/>
<stop offset="1" stop-color="#86410C"/>
</linearGradient>
<linearGradient id="paint11_linear_371_24252" x1="899.654" y1="96.255" x2="938.776" y2="113.746" gradientUnits="userSpaceOnUse">
<stop stop-color="#DD983D"/>
<stop offset="0.03" stop-color="#DD993E"/>
<stop offset="0.05" stop-color="#DF9F45"/>
<stop offset="0.06" stop-color="#E9B962"/>
<stop offset="0.07" stop-color="#F6DB88"/>
<stop offset="0.2" stop-color="#F5D986"/>
<stop offset="0.25" stop-color="#F2D37F"/>
<stop offset="0.28" stop-color="#EEC873"/>
<stop offset="0.31" stop-color="#E8B862"/>
<stop offset="0.33" stop-color="#E0A44C"/>
<stop offset="0.35" stop-color="#D68C32"/>
<stop offset="0.36" stop-color="#D28126"/>
<stop offset="0.49" stop-color="#CB6B1B"/>
<stop offset="0.67" stop-color="#C55619"/>
<stop offset="0.72" stop-color="#CD711B"/>
<stop offset="0.78" stop-color="#D4872B"/>
<stop offset="0.83" stop-color="#D78D31"/>
<stop offset="0.9" stop-color="#CB8226"/>
<stop offset="0.96" stop-color="#AD6614"/>
<stop offset="1" stop-color="#86410C"/>
</linearGradient>
<linearGradient id="paint12_linear_371_24252" x1="430.228" y1="89.8913" x2="437.919" y2="97.9126" gradientUnits="userSpaceOnUse">
<stop stop-color="#DD983D"/>
<stop offset="0.03" stop-color="#DD993E"/>
<stop offset="0.05" stop-color="#DF9F45"/>
<stop offset="0.06" stop-color="#E9B962"/>
<stop offset="0.07" stop-color="#F6DB88"/>
<stop offset="0.2" stop-color="#F5D986"/>
<stop offset="0.25" stop-color="#F2D37F"/>
<stop offset="0.28" stop-color="#EEC873"/>
<stop offset="0.31" stop-color="#E8B862"/>
<stop offset="0.33" stop-color="#E0A44C"/>
<stop offset="0.35" stop-color="#D68C32"/>
<stop offset="0.36" stop-color="#D28126"/>
<stop offset="0.49" stop-color="#CB6B1B"/>
<stop offset="0.67" stop-color="#C55619"/>
<stop offset="0.72" stop-color="#CD711B"/>
<stop offset="0.78" stop-color="#D4872B"/>
<stop offset="0.83" stop-color="#D78D31"/>
<stop offset="0.9" stop-color="#CB8226"/>
<stop offset="0.96" stop-color="#AD6614"/>
<stop offset="1" stop-color="#86410C"/>
</linearGradient>
<linearGradient id="paint13_linear_371_24252" x1="504.269" y1="88.9172" x2="500.291" y2="101.352" gradientUnits="userSpaceOnUse">
<stop stop-color="#DD983D"/>
<stop offset="0.03" stop-color="#DD993E"/>
<stop offset="0.05" stop-color="#DF9F45"/>
<stop offset="0.06" stop-color="#E9B962"/>
<stop offset="0.07" stop-color="#F6DB88"/>
<stop offset="0.2" stop-color="#F5D986"/>
<stop offset="0.25" stop-color="#F2D37F"/>
<stop offset="0.28" stop-color="#EEC873"/>
<stop offset="0.31" stop-color="#E8B862"/>
<stop offset="0.33" stop-color="#E0A44C"/>
<stop offset="0.35" stop-color="#D68C32"/>
<stop offset="0.36" stop-color="#D28126"/>
<stop offset="0.49" stop-color="#CB6B1B"/>
<stop offset="0.67" stop-color="#C55619"/>
<stop offset="0.72" stop-color="#CD711B"/>
<stop offset="0.78" stop-color="#D4872B"/>
<stop offset="0.83" stop-color="#D78D31"/>
<stop offset="0.9" stop-color="#CB8226"/>
<stop offset="0.96" stop-color="#AD6614"/>
<stop offset="1" stop-color="#86410C"/>
</linearGradient>
<linearGradient id="paint14_linear_371_24252" x1="478.167" y1="117.815" x2="477.693" y2="132.061" gradientUnits="userSpaceOnUse">
<stop stop-color="#DD983D"/>
<stop offset="0.03" stop-color="#DD993E"/>
<stop offset="0.05" stop-color="#DF9F45"/>
<stop offset="0.06" stop-color="#E9B962"/>
<stop offset="0.07" stop-color="#F6DB88"/>
<stop offset="0.2" stop-color="#F5D986"/>
<stop offset="0.25" stop-color="#F2D37F"/>
<stop offset="0.28" stop-color="#EEC873"/>
<stop offset="0.31" stop-color="#E8B862"/>
<stop offset="0.33" stop-color="#E0A44C"/>
<stop offset="0.35" stop-color="#D68C32"/>
<stop offset="0.36" stop-color="#D28126"/>
<stop offset="0.49" stop-color="#CB6B1B"/>
<stop offset="0.67" stop-color="#C55619"/>
<stop offset="0.72" stop-color="#CD711B"/>
<stop offset="0.78" stop-color="#D4872B"/>
<stop offset="0.83" stop-color="#D78D31"/>
<stop offset="0.9" stop-color="#CB8226"/>
<stop offset="0.96" stop-color="#AD6614"/>
<stop offset="1" stop-color="#86410C"/>
</linearGradient>
<linearGradient id="paint15_linear_371_24252" x1="394.075" y1="159.807" x2="425.636" y2="150.009" gradientUnits="userSpaceOnUse">
<stop stop-color="#DD983D"/>
<stop offset="0.03" stop-color="#DD993E"/>
<stop offset="0.05" stop-color="#DF9F45"/>
<stop offset="0.06" stop-color="#E9B962"/>
<stop offset="0.07" stop-color="#F6DB88"/>
<stop offset="0.2" stop-color="#F5D986"/>
<stop offset="0.25" stop-color="#F2D37F"/>
<stop offset="0.28" stop-color="#EEC873"/>
<stop offset="0.31" stop-color="#E8B862"/>
<stop offset="0.33" stop-color="#E0A44C"/>
<stop offset="0.35" stop-color="#D68C32"/>
<stop offset="0.36" stop-color="#D28126"/>
<stop offset="0.49" stop-color="#CB6B1B"/>
<stop offset="0.67" stop-color="#C55619"/>
<stop offset="0.72" stop-color="#CD711B"/>
<stop offset="0.78" stop-color="#D4872B"/>
<stop offset="0.83" stop-color="#D78D31"/>
<stop offset="0.9" stop-color="#CB8226"/>
<stop offset="0.96" stop-color="#AD6614"/>
<stop offset="1" stop-color="#86410C"/>
</linearGradient>
<linearGradient id="paint16_linear_371_24252" x1="314.549" y1="1.21348" x2="308.385" y2="10.46" gradientUnits="userSpaceOnUse">
<stop stop-color="#DD983D"/>
<stop offset="0.03" stop-color="#DD993E"/>
<stop offset="0.05" stop-color="#DF9F45"/>
<stop offset="0.06" stop-color="#E9B962"/>
<stop offset="0.07" stop-color="#F6DB88"/>
<stop offset="0.2" stop-color="#F5D986"/>
<stop offset="0.25" stop-color="#F2D37F"/>
<stop offset="0.28" stop-color="#EEC873"/>
<stop offset="0.31" stop-color="#E8B862"/>
<stop offset="0.33" stop-color="#E0A44C"/>
<stop offset="0.35" stop-color="#D68C32"/>
<stop offset="0.36" stop-color="#D28126"/>
<stop offset="0.49" stop-color="#CB6B1B"/>
<stop offset="0.67" stop-color="#C55619"/>
<stop offset="0.72" stop-color="#CD711B"/>
<stop offset="0.78" stop-color="#D4872B"/>
<stop offset="0.83" stop-color="#D78D31"/>
<stop offset="0.9" stop-color="#CB8226"/>
<stop offset="0.96" stop-color="#AD6614"/>
<stop offset="1" stop-color="#86410C"/>
</linearGradient>
<linearGradient id="paint17_linear_371_24252" x1="331.547" y1="73.2841" x2="318.546" y2="72.0957" gradientUnits="userSpaceOnUse">
<stop stop-color="#DD983D"/>
<stop offset="0.03" stop-color="#DD993E"/>
<stop offset="0.05" stop-color="#DF9F45"/>
<stop offset="0.06" stop-color="#E9B962"/>
<stop offset="0.07" stop-color="#F6DB88"/>
<stop offset="0.2" stop-color="#F5D986"/>
<stop offset="0.25" stop-color="#F2D37F"/>
<stop offset="0.28" stop-color="#EEC873"/>
<stop offset="0.31" stop-color="#E8B862"/>
<stop offset="0.33" stop-color="#E0A44C"/>
<stop offset="0.35" stop-color="#D68C32"/>
<stop offset="0.36" stop-color="#D28126"/>
<stop offset="0.49" stop-color="#CB6B1B"/>
<stop offset="0.67" stop-color="#C55619"/>
<stop offset="0.72" stop-color="#CD711B"/>
<stop offset="0.78" stop-color="#D4872B"/>
<stop offset="0.83" stop-color="#D78D31"/>
<stop offset="0.9" stop-color="#CB8226"/>
<stop offset="0.96" stop-color="#AD6614"/>
<stop offset="1" stop-color="#86410C"/>
</linearGradient>
<linearGradient id="paint18_linear_371_24252" x1="297.679" y1="54.0643" x2="283.669" y2="56.6899" gradientUnits="userSpaceOnUse">
<stop stop-color="#DD983D"/>
<stop offset="0.03" stop-color="#DD993E"/>
<stop offset="0.05" stop-color="#DF9F45"/>
<stop offset="0.06" stop-color="#E9B962"/>
<stop offset="0.07" stop-color="#F6DB88"/>
<stop offset="0.2" stop-color="#F5D986"/>
<stop offset="0.25" stop-color="#F2D37F"/>
<stop offset="0.28" stop-color="#EEC873"/>
<stop offset="0.31" stop-color="#E8B862"/>
<stop offset="0.33" stop-color="#E0A44C"/>
<stop offset="0.35" stop-color="#D68C32"/>
<stop offset="0.36" stop-color="#D28126"/>
<stop offset="0.49" stop-color="#CB6B1B"/>
<stop offset="0.67" stop-color="#C55619"/>
<stop offset="0.72" stop-color="#CD711B"/>
<stop offset="0.78" stop-color="#D4872B"/>
<stop offset="0.83" stop-color="#D78D31"/>
<stop offset="0.9" stop-color="#CB8226"/>
<stop offset="0.96" stop-color="#AD6614"/>
<stop offset="1" stop-color="#86410C"/>
</linearGradient>
<linearGradient id="paint19_linear_371_24252" x1="238.46" y1="-18.9269" x2="254.865" y2="9.75941" gradientUnits="userSpaceOnUse">
<stop stop-color="#DD983D"/>
<stop offset="0.03" stop-color="#DD993E"/>
<stop offset="0.05" stop-color="#DF9F45"/>
<stop offset="0.06" stop-color="#E9B962"/>
<stop offset="0.07" stop-color="#F6DB88"/>
<stop offset="0.2" stop-color="#F5D986"/>
<stop offset="0.25" stop-color="#F2D37F"/>
<stop offset="0.28" stop-color="#EEC873"/>
<stop offset="0.31" stop-color="#E8B862"/>
<stop offset="0.33" stop-color="#E0A44C"/>
<stop offset="0.35" stop-color="#D68C32"/>
<stop offset="0.36" stop-color="#D28126"/>
<stop offset="0.49" stop-color="#CB6B1B"/>
<stop offset="0.67" stop-color="#C55619"/>
<stop offset="0.72" stop-color="#CD711B"/>
<stop offset="0.78" stop-color="#D4872B"/>
<stop offset="0.83" stop-color="#D78D31"/>
<stop offset="0.9" stop-color="#CB8226"/>
<stop offset="0.96" stop-color="#AD6614"/>
<stop offset="1" stop-color="#86410C"/>
</linearGradient>
<linearGradient id="paint20_linear_371_24252" x1="29.898" y1="52.631" x2="37.5889" y2="60.6524" gradientUnits="userSpaceOnUse">
<stop stop-color="#DD983D"/>
<stop offset="0.03" stop-color="#DD993E"/>
<stop offset="0.05" stop-color="#DF9F45"/>
<stop offset="0.06" stop-color="#E9B962"/>
<stop offset="0.07" stop-color="#F6DB88"/>
<stop offset="0.2" stop-color="#F5D986"/>
<stop offset="0.25" stop-color="#F2D37F"/>
<stop offset="0.28" stop-color="#EEC873"/>
<stop offset="0.31" stop-color="#E8B862"/>
<stop offset="0.33" stop-color="#E0A44C"/>
<stop offset="0.35" stop-color="#D68C32"/>
<stop offset="0.36" stop-color="#D28126"/>
<stop offset="0.49" stop-color="#CB6B1B"/>
<stop offset="0.67" stop-color="#C55619"/>
<stop offset="0.72" stop-color="#CD711B"/>
<stop offset="0.78" stop-color="#D4872B"/>
<stop offset="0.83" stop-color="#D78D31"/>
<stop offset="0.9" stop-color="#CB8226"/>
<stop offset="0.96" stop-color="#AD6614"/>
<stop offset="1" stop-color="#86410C"/>
</linearGradient>
<linearGradient id="paint21_linear_371_24252" x1="103.939" y1="51.657" x2="99.9613" y2="64.0914" gradientUnits="userSpaceOnUse">
<stop stop-color="#DD983D"/>
<stop offset="0.03" stop-color="#DD993E"/>
<stop offset="0.05" stop-color="#DF9F45"/>
<stop offset="0.06" stop-color="#E9B962"/>
<stop offset="0.07" stop-color="#F6DB88"/>
<stop offset="0.2" stop-color="#F5D986"/>
<stop offset="0.25" stop-color="#F2D37F"/>
<stop offset="0.28" stop-color="#EEC873"/>
<stop offset="0.31" stop-color="#E8B862"/>
<stop offset="0.33" stop-color="#E0A44C"/>
<stop offset="0.35" stop-color="#D68C32"/>
<stop offset="0.36" stop-color="#D28126"/>
<stop offset="0.49" stop-color="#CB6B1B"/>
<stop offset="0.67" stop-color="#C55619"/>
<stop offset="0.72" stop-color="#CD711B"/>
<stop offset="0.78" stop-color="#D4872B"/>
<stop offset="0.83" stop-color="#D78D31"/>
<stop offset="0.9" stop-color="#CB8226"/>
<stop offset="0.96" stop-color="#AD6614"/>
<stop offset="1" stop-color="#86410C"/>
</linearGradient>
<linearGradient id="paint22_linear_371_24252" x1="77.8365" y1="80.5546" x2="77.3632" y2="94.8004" gradientUnits="userSpaceOnUse">
<stop stop-color="#DD983D"/>
<stop offset="0.03" stop-color="#DD993E"/>
<stop offset="0.05" stop-color="#DF9F45"/>
<stop offset="0.06" stop-color="#E9B962"/>
<stop offset="0.07" stop-color="#F6DB88"/>
<stop offset="0.2" stop-color="#F5D986"/>
<stop offset="0.25" stop-color="#F2D37F"/>
<stop offset="0.28" stop-color="#EEC873"/>
<stop offset="0.31" stop-color="#E8B862"/>
<stop offset="0.33" stop-color="#E0A44C"/>
<stop offset="0.35" stop-color="#D68C32"/>
<stop offset="0.36" stop-color="#D28126"/>
<stop offset="0.49" stop-color="#CB6B1B"/>
<stop offset="0.67" stop-color="#C55619"/>
<stop offset="0.72" stop-color="#CD711B"/>
<stop offset="0.78" stop-color="#D4872B"/>
<stop offset="0.83" stop-color="#D78D31"/>
<stop offset="0.9" stop-color="#CB8226"/>
<stop offset="0.96" stop-color="#AD6614"/>
<stop offset="1" stop-color="#86410C"/>
</linearGradient>
<linearGradient id="paint23_linear_371_24252" x1="-6.25479" y1="122.547" x2="25.3054" y2="112.748" gradientUnits="userSpaceOnUse">
<stop stop-color="#DD983D"/>
<stop offset="0.03" stop-color="#DD993E"/>
<stop offset="0.05" stop-color="#DF9F45"/>
<stop offset="0.06" stop-color="#E9B962"/>
<stop offset="0.07" stop-color="#F6DB88"/>
<stop offset="0.2" stop-color="#F5D986"/>
<stop offset="0.25" stop-color="#F2D37F"/>
<stop offset="0.28" stop-color="#EEC873"/>
<stop offset="0.31" stop-color="#E8B862"/>
<stop offset="0.33" stop-color="#E0A44C"/>
<stop offset="0.35" stop-color="#D68C32"/>
<stop offset="0.36" stop-color="#D28126"/>
<stop offset="0.49" stop-color="#CB6B1B"/>
<stop offset="0.67" stop-color="#C55619"/>
<stop offset="0.72" stop-color="#CD711B"/>
<stop offset="0.78" stop-color="#D4872B"/>
<stop offset="0.83" stop-color="#D78D31"/>
<stop offset="0.9" stop-color="#CB8226"/>
<stop offset="0.96" stop-color="#AD6614"/>
<stop offset="1" stop-color="#86410C"/>
</linearGradient>
<linearGradient id="paint24_linear_371_24252" x1="72.357" y1="159.213" x2="80.0478" y2="167.234" gradientUnits="userSpaceOnUse">
<stop stop-color="#DD983D"/>
<stop offset="0.03" stop-color="#DD993E"/>
<stop offset="0.05" stop-color="#DF9F45"/>
<stop offset="0.06" stop-color="#E9B962"/>
<stop offset="0.07" stop-color="#F6DB88"/>
<stop offset="0.2" stop-color="#F5D986"/>
<stop offset="0.25" stop-color="#F2D37F"/>
<stop offset="0.28" stop-color="#EEC873"/>
<stop offset="0.31" stop-color="#E8B862"/>
<stop offset="0.33" stop-color="#E0A44C"/>
<stop offset="0.35" stop-color="#D68C32"/>
<stop offset="0.36" stop-color="#D28126"/>
<stop offset="0.49" stop-color="#CB6B1B"/>
<stop offset="0.67" stop-color="#C55619"/>
<stop offset="0.72" stop-color="#CD711B"/>
<stop offset="0.78" stop-color="#D4872B"/>
<stop offset="0.83" stop-color="#D78D31"/>
<stop offset="0.9" stop-color="#CB8226"/>
<stop offset="0.96" stop-color="#AD6614"/>
<stop offset="1" stop-color="#86410C"/>
</linearGradient>
<linearGradient id="paint25_linear_371_24252" x1="146.398" y1="158.239" x2="142.42" y2="170.673" gradientUnits="userSpaceOnUse">
<stop stop-color="#DD983D"/>
<stop offset="0.03" stop-color="#DD993E"/>
<stop offset="0.05" stop-color="#DF9F45"/>
<stop offset="0.06" stop-color="#E9B962"/>
<stop offset="0.07" stop-color="#F6DB88"/>
<stop offset="0.2" stop-color="#F5D986"/>
<stop offset="0.25" stop-color="#F2D37F"/>
<stop offset="0.28" stop-color="#EEC873"/>
<stop offset="0.31" stop-color="#E8B862"/>
<stop offset="0.33" stop-color="#E0A44C"/>
<stop offset="0.35" stop-color="#D68C32"/>
<stop offset="0.36" stop-color="#D28126"/>
<stop offset="0.49" stop-color="#CB6B1B"/>
<stop offset="0.67" stop-color="#C55619"/>
<stop offset="0.72" stop-color="#CD711B"/>
<stop offset="0.78" stop-color="#D4872B"/>
<stop offset="0.83" stop-color="#D78D31"/>
<stop offset="0.9" stop-color="#CB8226"/>
<stop offset="0.96" stop-color="#AD6614"/>
<stop offset="1" stop-color="#86410C"/>
</linearGradient>
<linearGradient id="paint26_linear_371_24252" x1="120.296" y1="187.137" x2="119.822" y2="201.382" gradientUnits="userSpaceOnUse">
<stop stop-color="#DD983D"/>
<stop offset="0.03" stop-color="#DD993E"/>
<stop offset="0.05" stop-color="#DF9F45"/>
<stop offset="0.06" stop-color="#E9B962"/>
<stop offset="0.07" stop-color="#F6DB88"/>
<stop offset="0.2" stop-color="#F5D986"/>
<stop offset="0.25" stop-color="#F2D37F"/>
<stop offset="0.28" stop-color="#EEC873"/>
<stop offset="0.31" stop-color="#E8B862"/>
<stop offset="0.33" stop-color="#E0A44C"/>
<stop offset="0.35" stop-color="#D68C32"/>
<stop offset="0.36" stop-color="#D28126"/>
<stop offset="0.49" stop-color="#CB6B1B"/>
<stop offset="0.67" stop-color="#C55619"/>
<stop offset="0.72" stop-color="#CD711B"/>
<stop offset="0.78" stop-color="#D4872B"/>
<stop offset="0.83" stop-color="#D78D31"/>
<stop offset="0.9" stop-color="#CB8226"/>
<stop offset="0.96" stop-color="#AD6614"/>
<stop offset="1" stop-color="#86410C"/>
</linearGradient>
<linearGradient id="paint27_linear_371_24252" x1="36.2042" y1="229.129" x2="67.7644" y2="219.33" gradientUnits="userSpaceOnUse">
<stop stop-color="#DD983D"/>
<stop offset="0.03" stop-color="#DD993E"/>
<stop offset="0.05" stop-color="#DF9F45"/>
<stop offset="0.06" stop-color="#E9B962"/>
<stop offset="0.07" stop-color="#F6DB88"/>
<stop offset="0.2" stop-color="#F5D986"/>
<stop offset="0.25" stop-color="#F2D37F"/>
<stop offset="0.28" stop-color="#EEC873"/>
<stop offset="0.31" stop-color="#E8B862"/>
<stop offset="0.33" stop-color="#E0A44C"/>
<stop offset="0.35" stop-color="#D68C32"/>
<stop offset="0.36" stop-color="#D28126"/>
<stop offset="0.49" stop-color="#CB6B1B"/>
<stop offset="0.67" stop-color="#C55619"/>
<stop offset="0.72" stop-color="#CD711B"/>
<stop offset="0.78" stop-color="#D4872B"/>
<stop offset="0.83" stop-color="#D78D31"/>
<stop offset="0.9" stop-color="#CB8226"/>
<stop offset="0.96" stop-color="#AD6614"/>
<stop offset="1" stop-color="#86410C"/>
</linearGradient>
<linearGradient id="paint28_linear_371_24252" x1="258.658" y1="177.409" x2="266.349" y2="185.431" gradientUnits="userSpaceOnUse">
<stop stop-color="#DD983D"/>
<stop offset="0.03" stop-color="#DD993E"/>
<stop offset="0.05" stop-color="#DF9F45"/>
<stop offset="0.06" stop-color="#E9B962"/>
<stop offset="0.07" stop-color="#F6DB88"/>
<stop offset="0.2" stop-color="#F5D986"/>
<stop offset="0.25" stop-color="#F2D37F"/>
<stop offset="0.28" stop-color="#EEC873"/>
<stop offset="0.31" stop-color="#E8B862"/>
<stop offset="0.33" stop-color="#E0A44C"/>
<stop offset="0.35" stop-color="#D68C32"/>
<stop offset="0.36" stop-color="#D28126"/>
<stop offset="0.49" stop-color="#CB6B1B"/>
<stop offset="0.67" stop-color="#C55619"/>
<stop offset="0.72" stop-color="#CD711B"/>
<stop offset="0.78" stop-color="#D4872B"/>
<stop offset="0.83" stop-color="#D78D31"/>
<stop offset="0.9" stop-color="#CB8226"/>
<stop offset="0.96" stop-color="#AD6614"/>
<stop offset="1" stop-color="#86410C"/>
</linearGradient>
<linearGradient id="paint29_linear_371_24252" x1="332.699" y1="176.435" x2="328.721" y2="188.87" gradientUnits="userSpaceOnUse">
<stop stop-color="#DD983D"/>
<stop offset="0.03" stop-color="#DD993E"/>
<stop offset="0.05" stop-color="#DF9F45"/>
<stop offset="0.06" stop-color="#E9B962"/>
<stop offset="0.07" stop-color="#F6DB88"/>
<stop offset="0.2" stop-color="#F5D986"/>
<stop offset="0.25" stop-color="#F2D37F"/>
<stop offset="0.28" stop-color="#EEC873"/>
<stop offset="0.31" stop-color="#E8B862"/>
<stop offset="0.33" stop-color="#E0A44C"/>
<stop offset="0.35" stop-color="#D68C32"/>
<stop offset="0.36" stop-color="#D28126"/>
<stop offset="0.49" stop-color="#CB6B1B"/>
<stop offset="0.67" stop-color="#C55619"/>
<stop offset="0.72" stop-color="#CD711B"/>
<stop offset="0.78" stop-color="#D4872B"/>
<stop offset="0.83" stop-color="#D78D31"/>
<stop offset="0.9" stop-color="#CB8226"/>
<stop offset="0.96" stop-color="#AD6614"/>
<stop offset="1" stop-color="#86410C"/>
</linearGradient>
<linearGradient id="paint30_linear_371_24252" x1="306.596" y1="205.333" x2="306.123" y2="219.579" gradientUnits="userSpaceOnUse">
<stop stop-color="#DD983D"/>
<stop offset="0.03" stop-color="#DD993E"/>
<stop offset="0.05" stop-color="#DF9F45"/>
<stop offset="0.06" stop-color="#E9B962"/>
<stop offset="0.07" stop-color="#F6DB88"/>
<stop offset="0.2" stop-color="#F5D986"/>
<stop offset="0.25" stop-color="#F2D37F"/>
<stop offset="0.28" stop-color="#EEC873"/>
<stop offset="0.31" stop-color="#E8B862"/>
<stop offset="0.33" stop-color="#E0A44C"/>
<stop offset="0.35" stop-color="#D68C32"/>
<stop offset="0.36" stop-color="#D28126"/>
<stop offset="0.49" stop-color="#CB6B1B"/>
<stop offset="0.67" stop-color="#C55619"/>
<stop offset="0.72" stop-color="#CD711B"/>
<stop offset="0.78" stop-color="#D4872B"/>
<stop offset="0.83" stop-color="#D78D31"/>
<stop offset="0.9" stop-color="#CB8226"/>
<stop offset="0.96" stop-color="#AD6614"/>
<stop offset="1" stop-color="#86410C"/>
</linearGradient>
<linearGradient id="paint31_linear_371_24252" x1="222.505" y1="247.325" x2="254.065" y2="237.527" gradientUnits="userSpaceOnUse">
<stop stop-color="#DD983D"/>
<stop offset="0.03" stop-color="#DD993E"/>
<stop offset="0.05" stop-color="#DF9F45"/>
<stop offset="0.06" stop-color="#E9B962"/>
<stop offset="0.07" stop-color="#F6DB88"/>
<stop offset="0.2" stop-color="#F5D986"/>
<stop offset="0.25" stop-color="#F2D37F"/>
<stop offset="0.28" stop-color="#EEC873"/>
<stop offset="0.31" stop-color="#E8B862"/>
<stop offset="0.33" stop-color="#E0A44C"/>
<stop offset="0.35" stop-color="#D68C32"/>
<stop offset="0.36" stop-color="#D28126"/>
<stop offset="0.49" stop-color="#CB6B1B"/>
<stop offset="0.67" stop-color="#C55619"/>
<stop offset="0.72" stop-color="#CD711B"/>
<stop offset="0.78" stop-color="#D4872B"/>
<stop offset="0.83" stop-color="#D78D31"/>
<stop offset="0.9" stop-color="#CB8226"/>
<stop offset="0.96" stop-color="#AD6614"/>
<stop offset="1" stop-color="#86410C"/>
</linearGradient>
<linearGradient id="paint32_linear_371_24252" x1="1083.24" y1="147.58" x2="1091.79" y2="156.442" gradientUnits="userSpaceOnUse">
<stop stop-color="#DD983D"/>
<stop offset="0.03" stop-color="#DD993E"/>
<stop offset="0.05" stop-color="#DF9F45"/>
<stop offset="0.06" stop-color="#E9B962"/>
<stop offset="0.07" stop-color="#F6DB88"/>
<stop offset="0.2" stop-color="#F5D986"/>
<stop offset="0.25" stop-color="#F2D37F"/>
<stop offset="0.28" stop-color="#EEC873"/>
<stop offset="0.31" stop-color="#E8B862"/>
<stop offset="0.33" stop-color="#E0A44C"/>
<stop offset="0.35" stop-color="#D68C32"/>
<stop offset="0.36" stop-color="#D28126"/>
<stop offset="0.49" stop-color="#CB6B1B"/>
<stop offset="0.67" stop-color="#C55619"/>
<stop offset="0.72" stop-color="#CD711B"/>
<stop offset="0.78" stop-color="#D4872B"/>
<stop offset="0.83" stop-color="#D78D31"/>
<stop offset="0.9" stop-color="#CB8226"/>
<stop offset="0.96" stop-color="#AD6614"/>
<stop offset="1" stop-color="#86410C"/>
</linearGradient>
<linearGradient id="paint33_linear_371_24252" x1="1136.35" y1="178.493" x2="1135.86" y2="194.303" gradientUnits="userSpaceOnUse">
<stop stop-color="#DD983D"/>
<stop offset="0.03" stop-color="#DD993E"/>
<stop offset="0.05" stop-color="#DF9F45"/>
<stop offset="0.06" stop-color="#E9B962"/>
<stop offset="0.07" stop-color="#F6DB88"/>
<stop offset="0.2" stop-color="#F5D986"/>
<stop offset="0.25" stop-color="#F2D37F"/>
<stop offset="0.28" stop-color="#EEC873"/>
<stop offset="0.31" stop-color="#E8B862"/>
<stop offset="0.33" stop-color="#E0A44C"/>
<stop offset="0.35" stop-color="#D68C32"/>
<stop offset="0.36" stop-color="#D28126"/>
<stop offset="0.49" stop-color="#CB6B1B"/>
<stop offset="0.67" stop-color="#C55619"/>
<stop offset="0.72" stop-color="#CD711B"/>
<stop offset="0.78" stop-color="#D4872B"/>
<stop offset="0.83" stop-color="#D78D31"/>
<stop offset="0.9" stop-color="#CB8226"/>
<stop offset="0.96" stop-color="#AD6614"/>
<stop offset="1" stop-color="#86410C"/>
</linearGradient>
<linearGradient id="paint34_linear_371_24252" x1="1043.19" y1="225.014" x2="1078.16" y2="214.158" gradientUnits="userSpaceOnUse">
<stop stop-color="#DD983D"/>
<stop offset="0.03" stop-color="#DD993E"/>
<stop offset="0.05" stop-color="#DF9F45"/>
<stop offset="0.06" stop-color="#E9B962"/>
<stop offset="0.07" stop-color="#F6DB88"/>
<stop offset="0.2" stop-color="#F5D986"/>
<stop offset="0.25" stop-color="#F2D37F"/>
<stop offset="0.28" stop-color="#EEC873"/>
<stop offset="0.31" stop-color="#E8B862"/>
<stop offset="0.33" stop-color="#E0A44C"/>
<stop offset="0.35" stop-color="#D68C32"/>
<stop offset="0.36" stop-color="#D28126"/>
<stop offset="0.49" stop-color="#CB6B1B"/>
<stop offset="0.67" stop-color="#C55619"/>
<stop offset="0.72" stop-color="#CD711B"/>
<stop offset="0.78" stop-color="#D4872B"/>
<stop offset="0.83" stop-color="#D78D31"/>
<stop offset="0.9" stop-color="#CB8226"/>
<stop offset="0.96" stop-color="#AD6614"/>
<stop offset="1" stop-color="#86410C"/>
</linearGradient>
<linearGradient id="paint35_linear_371_24252" x1="665.191" y1="167.742" x2="669.053" y2="171.758" gradientUnits="userSpaceOnUse">
<stop stop-color="#DD983D"/>
<stop offset="0.03" stop-color="#DD993E"/>
<stop offset="0.05" stop-color="#DF9F45"/>
<stop offset="0.06" stop-color="#E9B962"/>
<stop offset="0.07" stop-color="#F6DB88"/>
<stop offset="0.2" stop-color="#F5D986"/>
<stop offset="0.25" stop-color="#F2D37F"/>
<stop offset="0.28" stop-color="#EEC873"/>
<stop offset="0.31" stop-color="#E8B862"/>
<stop offset="0.33" stop-color="#E0A44C"/>
<stop offset="0.35" stop-color="#D68C32"/>
<stop offset="0.36" stop-color="#D28126"/>
<stop offset="0.49" stop-color="#CB6B1B"/>
<stop offset="0.67" stop-color="#C55619"/>
<stop offset="0.72" stop-color="#CD711B"/>
<stop offset="0.78" stop-color="#D4872B"/>
<stop offset="0.83" stop-color="#D78D31"/>
<stop offset="0.9" stop-color="#CB8226"/>
<stop offset="0.96" stop-color="#AD6614"/>
<stop offset="1" stop-color="#86410C"/>
</linearGradient>
<linearGradient id="paint36_linear_371_24252" x1="702.367" y1="167.249" x2="700.358" y2="173.496" gradientUnits="userSpaceOnUse">
<stop stop-color="#DD983D"/>
<stop offset="0.03" stop-color="#DD993E"/>
<stop offset="0.05" stop-color="#DF9F45"/>
<stop offset="0.06" stop-color="#E9B962"/>
<stop offset="0.07" stop-color="#F6DB88"/>
<stop offset="0.2" stop-color="#F5D986"/>
<stop offset="0.25" stop-color="#F2D37F"/>
<stop offset="0.28" stop-color="#EEC873"/>
<stop offset="0.31" stop-color="#E8B862"/>
<stop offset="0.33" stop-color="#E0A44C"/>
<stop offset="0.35" stop-color="#D68C32"/>
<stop offset="0.36" stop-color="#D28126"/>
<stop offset="0.49" stop-color="#CB6B1B"/>
<stop offset="0.67" stop-color="#C55619"/>
<stop offset="0.72" stop-color="#CD711B"/>
<stop offset="0.78" stop-color="#D4872B"/>
<stop offset="0.83" stop-color="#D78D31"/>
<stop offset="0.9" stop-color="#CB8226"/>
<stop offset="0.96" stop-color="#AD6614"/>
<stop offset="1" stop-color="#86410C"/>
</linearGradient>
<linearGradient id="paint37_linear_371_24252" x1="689.261" y1="181.752" x2="689.024" y2="188.917" gradientUnits="userSpaceOnUse">
<stop stop-color="#DD983D"/>
<stop offset="0.03" stop-color="#DD993E"/>
<stop offset="0.05" stop-color="#DF9F45"/>
<stop offset="0.06" stop-color="#E9B962"/>
<stop offset="0.07" stop-color="#F6DB88"/>
<stop offset="0.2" stop-color="#F5D986"/>
<stop offset="0.25" stop-color="#F2D37F"/>
<stop offset="0.28" stop-color="#EEC873"/>
<stop offset="0.31" stop-color="#E8B862"/>
<stop offset="0.33" stop-color="#E0A44C"/>
<stop offset="0.35" stop-color="#D68C32"/>
<stop offset="0.36" stop-color="#D28126"/>
<stop offset="0.49" stop-color="#CB6B1B"/>
<stop offset="0.67" stop-color="#C55619"/>
<stop offset="0.72" stop-color="#CD711B"/>
<stop offset="0.78" stop-color="#D4872B"/>
<stop offset="0.83" stop-color="#D78D31"/>
<stop offset="0.9" stop-color="#CB8226"/>
<stop offset="0.96" stop-color="#AD6614"/>
<stop offset="1" stop-color="#86410C"/>
</linearGradient>
<linearGradient id="paint38_linear_371_24252" x1="647.034" y1="202.849" x2="662.889" y2="197.92" gradientUnits="userSpaceOnUse">
<stop stop-color="#DD983D"/>
<stop offset="0.03" stop-color="#DD993E"/>
<stop offset="0.05" stop-color="#DF9F45"/>
<stop offset="0.06" stop-color="#E9B962"/>
<stop offset="0.07" stop-color="#F6DB88"/>
<stop offset="0.2" stop-color="#F5D986"/>
<stop offset="0.25" stop-color="#F2D37F"/>
<stop offset="0.28" stop-color="#EEC873"/>
<stop offset="0.31" stop-color="#E8B862"/>
<stop offset="0.33" stop-color="#E0A44C"/>
<stop offset="0.35" stop-color="#D68C32"/>
<stop offset="0.36" stop-color="#D28126"/>
<stop offset="0.49" stop-color="#CB6B1B"/>
<stop offset="0.67" stop-color="#C55619"/>
<stop offset="0.72" stop-color="#CD711B"/>
<stop offset="0.78" stop-color="#D4872B"/>
<stop offset="0.83" stop-color="#D78D31"/>
<stop offset="0.9" stop-color="#CB8226"/>
<stop offset="0.96" stop-color="#AD6614"/>
<stop offset="1" stop-color="#86410C"/>
</linearGradient>
<linearGradient id="paint39_linear_371_24252" x1="1053.36" y1="87.1468" x2="1061.31" y2="78.8557" gradientUnits="userSpaceOnUse">
<stop stop-color="#DD983D"/>
<stop offset="0.03" stop-color="#DD993E"/>
<stop offset="0.05" stop-color="#DF9F45"/>
<stop offset="0.06" stop-color="#E9B962"/>
<stop offset="0.07" stop-color="#F6DB88"/>
<stop offset="0.2" stop-color="#F5D986"/>
<stop offset="0.25" stop-color="#F2D37F"/>
<stop offset="0.28" stop-color="#EEC873"/>
<stop offset="0.31" stop-color="#E8B862"/>
<stop offset="0.33" stop-color="#E0A44C"/>
<stop offset="0.35" stop-color="#D68C32"/>
<stop offset="0.36" stop-color="#D28126"/>
<stop offset="0.49" stop-color="#CB6B1B"/>
<stop offset="0.67" stop-color="#C55619"/>
<stop offset="0.72" stop-color="#CD711B"/>
<stop offset="0.78" stop-color="#D4872B"/>
<stop offset="0.83" stop-color="#D78D31"/>
<stop offset="0.9" stop-color="#CB8226"/>
<stop offset="0.96" stop-color="#AD6614"/>
<stop offset="1" stop-color="#86410C"/>
</linearGradient>
<linearGradient id="paint40_linear_371_24252" x1="1129.88" y1="88.1495" x2="1125.77" y2="75.297" gradientUnits="userSpaceOnUse">
<stop stop-color="#DD983D"/>
<stop offset="0.03" stop-color="#DD993E"/>
<stop offset="0.05" stop-color="#DF9F45"/>
<stop offset="0.06" stop-color="#E9B962"/>
<stop offset="0.07" stop-color="#F6DB88"/>
<stop offset="0.2" stop-color="#F5D986"/>
<stop offset="0.25" stop-color="#F2D37F"/>
<stop offset="0.28" stop-color="#EEC873"/>
<stop offset="0.31" stop-color="#E8B862"/>
<stop offset="0.33" stop-color="#E0A44C"/>
<stop offset="0.35" stop-color="#D68C32"/>
<stop offset="0.36" stop-color="#D28126"/>
<stop offset="0.49" stop-color="#CB6B1B"/>
<stop offset="0.67" stop-color="#C55619"/>
<stop offset="0.72" stop-color="#CD711B"/>
<stop offset="0.78" stop-color="#D4872B"/>
<stop offset="0.83" stop-color="#D78D31"/>
<stop offset="0.9" stop-color="#CB8226"/>
<stop offset="0.96" stop-color="#AD6614"/>
<stop offset="1" stop-color="#86410C"/>
</linearGradient>
<linearGradient id="paint41_linear_371_24252" x1="1102.91" y1="58.2837" x2="1102.42" y2="43.559" gradientUnits="userSpaceOnUse">
<stop stop-color="#DD983D"/>
<stop offset="0.03" stop-color="#DD993E"/>
<stop offset="0.05" stop-color="#DF9F45"/>
<stop offset="0.06" stop-color="#E9B962"/>
<stop offset="0.07" stop-color="#F6DB88"/>
<stop offset="0.2" stop-color="#F5D986"/>
<stop offset="0.25" stop-color="#F2D37F"/>
<stop offset="0.28" stop-color="#EEC873"/>
<stop offset="0.31" stop-color="#E8B862"/>
<stop offset="0.33" stop-color="#E0A44C"/>
<stop offset="0.35" stop-color="#D68C32"/>
<stop offset="0.36" stop-color="#D28126"/>
<stop offset="0.49" stop-color="#CB6B1B"/>
<stop offset="0.67" stop-color="#C55619"/>
<stop offset="0.72" stop-color="#CD711B"/>
<stop offset="0.78" stop-color="#D4872B"/>
<stop offset="0.83" stop-color="#D78D31"/>
<stop offset="0.9" stop-color="#CB8226"/>
<stop offset="0.96" stop-color="#AD6614"/>
<stop offset="1" stop-color="#86410C"/>
</linearGradient>
<linearGradient id="paint42_linear_371_24252" x1="1015.99" y1="14.8788" x2="1048.61" y2="25.0066" gradientUnits="userSpaceOnUse">
<stop stop-color="#DD983D"/>
<stop offset="0.03" stop-color="#DD993E"/>
<stop offset="0.05" stop-color="#DF9F45"/>
<stop offset="0.06" stop-color="#E9B962"/>
<stop offset="0.07" stop-color="#F6DB88"/>
<stop offset="0.2" stop-color="#F5D986"/>
<stop offset="0.25" stop-color="#F2D37F"/>
<stop offset="0.28" stop-color="#EEC873"/>
<stop offset="0.31" stop-color="#E8B862"/>
<stop offset="0.33" stop-color="#E0A44C"/>
<stop offset="0.35" stop-color="#D68C32"/>
<stop offset="0.36" stop-color="#D28126"/>
<stop offset="0.49" stop-color="#CB6B1B"/>
<stop offset="0.67" stop-color="#C55619"/>
<stop offset="0.72" stop-color="#CD711B"/>
<stop offset="0.78" stop-color="#D4872B"/>
<stop offset="0.83" stop-color="#D78D31"/>
<stop offset="0.9" stop-color="#CB8226"/>
<stop offset="0.96" stop-color="#AD6614"/>
<stop offset="1" stop-color="#86410C"/>
</linearGradient>
<linearGradient id="paint43_linear_371_24252" x1="828.839" y1="-5.48658" x2="826.841" y2="0.757151" gradientUnits="userSpaceOnUse">
<stop stop-color="#DD983D"/>
<stop offset="0.03" stop-color="#DD993E"/>
<stop offset="0.05" stop-color="#DF9F45"/>
<stop offset="0.06" stop-color="#E9B962"/>
<stop offset="0.07" stop-color="#F6DB88"/>
<stop offset="0.2" stop-color="#F5D986"/>
<stop offset="0.25" stop-color="#F2D37F"/>
<stop offset="0.28" stop-color="#EEC873"/>
<stop offset="0.31" stop-color="#E8B862"/>
<stop offset="0.33" stop-color="#E0A44C"/>
<stop offset="0.35" stop-color="#D68C32"/>
<stop offset="0.36" stop-color="#D28126"/>
<stop offset="0.49" stop-color="#CB6B1B"/>
<stop offset="0.67" stop-color="#C55619"/>
<stop offset="0.72" stop-color="#CD711B"/>
<stop offset="0.78" stop-color="#D4872B"/>
<stop offset="0.83" stop-color="#D78D31"/>
<stop offset="0.9" stop-color="#CB8226"/>
<stop offset="0.96" stop-color="#AD6614"/>
<stop offset="1" stop-color="#86410C"/>
</linearGradient>
<linearGradient id="paint44_linear_371_24252" x1="815.739" y1="9.01617" x2="815.501" y2="16.1694" gradientUnits="userSpaceOnUse">
<stop stop-color="#DD983D"/>
<stop offset="0.03" stop-color="#DD993E"/>
<stop offset="0.05" stop-color="#DF9F45"/>
<stop offset="0.06" stop-color="#E9B962"/>
<stop offset="0.07" stop-color="#F6DB88"/>
<stop offset="0.2" stop-color="#F5D986"/>
<stop offset="0.25" stop-color="#F2D37F"/>
<stop offset="0.28" stop-color="#EEC873"/>
<stop offset="0.31" stop-color="#E8B862"/>
<stop offset="0.33" stop-color="#E0A44C"/>
<stop offset="0.35" stop-color="#D68C32"/>
<stop offset="0.36" stop-color="#D28126"/>
<stop offset="0.49" stop-color="#CB6B1B"/>
<stop offset="0.67" stop-color="#C55619"/>
<stop offset="0.72" stop-color="#CD711B"/>
<stop offset="0.78" stop-color="#D4872B"/>
<stop offset="0.83" stop-color="#D78D31"/>
<stop offset="0.9" stop-color="#CB8226"/>
<stop offset="0.96" stop-color="#AD6614"/>
<stop offset="1" stop-color="#86410C"/>
</linearGradient>
<linearGradient id="paint45_linear_371_24252" x1="773.502" y1="30.0998" x2="789.349" y2="25.1798" gradientUnits="userSpaceOnUse">
<stop stop-color="#DD983D"/>
<stop offset="0.03" stop-color="#DD993E"/>
<stop offset="0.05" stop-color="#DF9F45"/>
<stop offset="0.06" stop-color="#E9B962"/>
<stop offset="0.07" stop-color="#F6DB88"/>
<stop offset="0.2" stop-color="#F5D986"/>
<stop offset="0.25" stop-color="#F2D37F"/>
<stop offset="0.28" stop-color="#EEC873"/>
<stop offset="0.31" stop-color="#E8B862"/>
<stop offset="0.33" stop-color="#E0A44C"/>
<stop offset="0.35" stop-color="#D68C32"/>
<stop offset="0.36" stop-color="#D28126"/>
<stop offset="0.49" stop-color="#CB6B1B"/>
<stop offset="0.67" stop-color="#C55619"/>
<stop offset="0.72" stop-color="#CD711B"/>
<stop offset="0.78" stop-color="#D4872B"/>
<stop offset="0.83" stop-color="#D78D31"/>
<stop offset="0.9" stop-color="#CB8226"/>
<stop offset="0.96" stop-color="#AD6614"/>
<stop offset="1" stop-color="#86410C"/>
</linearGradient>
<linearGradient id="paint46_linear_371_24252" x1="938.383" y1="45.2296" x2="899.099" y2="51.5825" gradientUnits="userSpaceOnUse">
<stop stop-color="#DD983D"/>
<stop offset="0.03" stop-color="#DD993E"/>
<stop offset="0.05" stop-color="#DF9F45"/>
<stop offset="0.06" stop-color="#E9B962"/>
<stop offset="0.07" stop-color="#F6DB88"/>
<stop offset="0.2" stop-color="#F5D986"/>
<stop offset="0.25" stop-color="#F2D37F"/>
<stop offset="0.28" stop-color="#EEC873"/>
<stop offset="0.31" stop-color="#E8B862"/>
<stop offset="0.33" stop-color="#E0A44C"/>
<stop offset="0.35" stop-color="#D68C32"/>
<stop offset="0.36" stop-color="#D28126"/>
<stop offset="0.49" stop-color="#CB6B1B"/>
<stop offset="0.67" stop-color="#C55619"/>
<stop offset="0.72" stop-color="#CD711B"/>
<stop offset="0.78" stop-color="#D4872B"/>
<stop offset="0.83" stop-color="#D78D31"/>
<stop offset="0.9" stop-color="#CB8226"/>
<stop offset="0.96" stop-color="#AD6614"/>
<stop offset="1" stop-color="#86410C"/>
</linearGradient>
</defs>
</svg>

</template>

<script>
export default {
  name: "RewardBannerItem1",
};
</script>